import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  WritableSignal,
  computed,
  effect,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClarityModule, ClrSelectedState } from '@clr/angular';
// Ol Imports
import OlGeolocation from 'ol/Geolocation';
import OlMap from 'ol/Map';
import OlView from 'ol/View';
import OlTopoJSON from 'ol/format/GeoJSON';
import { Type } from 'ol/geom/Geometry';
import Draw from 'ol/interaction/Draw';
import OlVectorLayer from 'ol/layer/Vector';
import { register } from 'ol/proj/proj4.js';
import OlVectorSource from 'ol/source/Vector';
import ol_format_WKB from 'ol/format/WKB';
import KML from 'ol/format/KML.js';
import Polygon from 'ol/geom/Polygon';

import SearchFeature from 'ol-ext/control/SearchFeature';
import OlPolygon from 'ol/geom/Polygon';
import OlSelect from 'ol/interaction/Select';
import OlFill from 'ol/style/Fill';
import OlStroke from 'ol/style/Stroke';
import OlStyle from 'ol/style/Style';

import { DragBox, Modify, Snap, defaults as defaultInt } from 'ol/interaction';

import { defaults } from 'ol/control';
import OlAttribution from 'ol/control/Attribution';
import OlFullScreen from 'ol/control/FullScreen';
import { platformModifierKeyOnly, pointerMove, singleClick } from 'ol/events/condition';
import OSMXML from 'ol/format/OSMXML';
import CircleStyle from 'ol/style/Circle';

import { fromLonLat, toLonLat } from 'ol/proj';

import * as proj4 from 'proj4';
import shp from 'shpjs';

import { ToastService } from 'src/app/services/toast.service';
import { delay, filter, first, take } from 'rxjs/operators';
import { APIService } from 'src/app/services/APIService/api.service';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';

import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import JSZip from 'jszip';
import { Feature, View } from 'ol';
import { Coordinate } from 'ol/coordinate';
import { Geometry, LineString, Point } from 'ol/geom';
import { getLength as geoDesLength, getLength } from 'ol/sphere';
import Fill from 'ol/style/Fill';
import Icon from 'ol/style/Icon';
import Stroke from 'ol/style/Stroke';
import OlText from 'ol/style/Text';
import { BehaviorSubject, Subscription, combineLatest, firstValueFrom } from 'rxjs';
import { addUnitAbbreviationToText, convertValueToUnit, duplicate, getTokenRight } from 'src/app/misc/functions';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { ObjTypePipe as objtype } from 'src/app/pipes/objtype.pipe';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { PersistanceService } from 'src/app/services/localstorage.service';
import { environment } from 'src/environments/environment';
import { DotDotDotPipe } from '../../pipes/dot-dot-dot.pipe';
import { HideIDColumnsPipe } from '../../pipes/hide-idcolumns.pipe';
import { TablePrettyPrintPipe } from '../../pipes/tablePrettyPrint.pipe';
import { DetailviewComponent } from '../_components/detailview/detailview.component';
import { ProgressbarComponent } from '../_components/progressbar/progressbar.component';
import { GleismessdatenmodalComponent } from './gleismessdatenmodal/gleismessdatenmodal.component';
import { ElementStylesObj, TileLayerObj } from './ol-exports';
import { AppDB } from 'src/app/services/_offline/dexieDB';
import { dbS } from 'src/app/services/_offline/StorageDexie';
import { toSignal } from '@angular/core/rxjs-interop';
import { SOTYP_Map } from 'src/app/models/api/SOTYP';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FileUploadService } from 'src/app/services/fileuploadprogress.service';
import { WebSocketService } from 'src/app/services/Websocket/websocket.service';
import { FilterService } from '../_components/filter/filter.service';
import { ColumnFilterChange, ColumnFilterComponent } from '../_components/filter/column-filter/column-filter.component';
import { getTypeIconCombination, getUniqueValues } from 'src/app/models/ui/table';
import { Base64Service } from 'src/app/services/base64/base64.service';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Options, NgxSliderModule } from '@angular-slider/ngx-slider';
import * as Plotly from 'plotly.js-basic-dist-min';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmService } from 'src/app/services/confirm.service';
import { AlkisAPI, AlkisZuordnung } from 'src/app/types/alkis';
import { FeatureCollection, Feature as GeoJSONFeature, Geometry as GeoJSONGeometry } from 'geojson';
import { GeoJSONExporter } from './json2shp';
import { ColorPickerDirective } from 'ngx-color-picker';
import Style from 'ol/style/Style';
import Collection from 'ol/Collection';
import { AlertService } from 'src/app/services/alert.service';
import { Overlay, OverlaySelectSearch } from './overlay-select-search/overlay-select-search';
import { getWidth } from 'ol/extent';
import { PrüfungsTypStore } from 'src/app/services/Shared/prüfung-typ.store';
import OlOverlay from 'ol/Overlay';
import { ICONS } from 'src/app/clarity-icons';
interface MatchRow {
  shpField: string | null;
  mrField: string | null;
}

interface CurrentColor {
  color: string;
  wert: string;
}

interface InputInfo {
  color: string;
  key: string;
  i: number;
  j: number;
}

const originalStyle = new Style({
  image: new CircleStyle({
    radius: 5,
    fill: new Fill({ color: 'blue' }),
    stroke: new Stroke({ color: 'white', width: 1 }),
  }),
});

const midpointStyle = new Style({
  image: new CircleStyle({
    radius: 6,
    fill: new Fill({ color: 'lightgray' }),
    stroke: new Stroke({ color: 'white', width: 2 }),
  }),
});

const dragBox = new DragBox({
  condition: platformModifierKeyOnly,
});
const production = true;
const retina =
  window.devicePixelRatio > 1 ?
    window.devicePixelRatio > 2 ?
      3
    : 2
  : 1;
type drawT = 'LineString' | 'Circle' | 'Polygon' | 'None' | '';
type actionT =
  | 'draw'
  | 'cut'
  | 'separate'
  | 'merge'
  | 'place'
  | 'placeTO'
  | 'rotate'
  | 'move'
  | 'modify'
  | 'getPos'
  | 'measure'
  | 'sort'
  | 'drawarc'
  | 'moveAll'
  | '';
type Compression = 'STORE' | 'DEFLATE';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-gismap',
  templateUrl: './gismap.component.html',
  styleUrls: ['./gismap.component.scss'],
  providers: [PersistanceService, WebSocketService],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    GleismessdatenmodalComponent,
    DetailviewComponent,
    ProgressbarComponent,
    TablePrettyPrintPipe,
    HideIDColumnsPipe,
    ColorPickerDirective,
    DotDotDotPipe,
    MrTranslatePipe,
    ColumnFilterComponent,
    NgxSliderModule,
    OverlaySelectSearch,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class GISMapComponent implements AfterViewInit, OnDestroy, OnInit {
  private readonly repDB = inject(AppDB);
  private readonly apiservice = inject(APIService);
  private readonly authService = inject(AuthService);
  private readonly basicStore = inject(BasicStoreService);
  private readonly toastr = inject(ToastService);
  private readonly spinner = inject(SpinnerService);
  private readonly base64service = inject(Base64Service);
  private readonly router = inject(Router);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly route = inject(ActivatedRoute);
  private readonly persistanceService = inject(PersistanceService);
  private readonly http = inject(HttpClient);
  private readonly fileUploadService = inject(FileUploadService);
  private readonly alertService = inject(AlertService);
  private readonly confirmService = inject(ConfirmService);
  private readonly webSocket = inject(WebSocketService);
  private readonly pruefungsTyp = inject(PrüfungsTypStore);

  doshowFeatureMenu: boolean = false;
  _ostammid: number = undefined;
  gisPos: number = 0;
  rechte: number = 1;
  set ostammid(val: number) {
    if (val) {
      if (!this.showdetailview) {
        this.showdetailview = true;
      }
      this.map && this.updateMapSize();
      this._ostammid = val;
    } else {
      this._ostammid = undefined;
    }
  }

  get ostammid() {
    return this._ostammid;
  }

  modalLinkGroup = new UntypedFormGroup({
    objTyp: new UntypedFormControl('', [Validators.required]),
    StammID: new UntypedFormControl('', [Validators.required]),
  });

  modalTOEditor = new UntypedFormGroup({
    WeichenTyp: new UntypedFormControl('', [Validators.required]),
    Bezeichnung: new UntypedFormControl('', [Validators.required]),
    BezPosition: new UntypedFormControl('', [Validators.required]),
    Position: new UntypedFormControl('', [Validators.required]),
    richtung: new UntypedFormControl(''),
    PositionCut: new UntypedFormControl(''),
    PositionMouse: new UntypedFormControl(''),
  });

  modalCutEditor = new UntypedFormGroup({
    PositionCut: new UntypedFormControl(''),
  });

  protected tb1: WritableSignal<string> = signal('');
  protected tb2: WritableSignal<string> = signal('');
  protected tb3: WritableSignal<string> = signal('');
  protected tb4: WritableSignal<string> = signal('');
  protected tb5: WritableSignal<string> = signal('');
  protected tb6: WritableSignal<string> = signal('');
  protected position = viewChild<string>('position');
  protected positionHover = viewChild<string>('positionhover');
  protected PositionCut = signal<number>(0);
  protected readonly info = signal<string>('info');
  protected readonly GeoPosMove = signal<string>('');
  protected readonly SetName = signal<string>('');
  protected readonly selMapSet = signal<string>('');
  protected readonly fileInputSHP = signal<string>('');
  protected readonly fileInputGPKG = signal<string>('');
  protected readonly posStyle = signal<string>('visibility:hidden');
  protected readonly posHTML = signal<string>('');
  protected readonly infoStyle = signal<string>('visibility:hidden');
  protected readonly infoHTML = signal<string>('');
  protected readonly tb1Style = signal<string>('top:0px;left:0px');
  protected readonly tb2Style = signal<string>('top:0px;left:0px');
  protected readonly tb3Style = signal<string>('top:0px;left:0px');
  protected readonly tb4Style = signal<string>('top:0px;left:0px');
  protected readonly tb5Style = signal<string>('top:0px;left:0px');
  protected readonly tb6Style = signal<string>('top:0px;left:0px');

  protected readonly selKilometerName = signal<string>('');

  @ViewChild('popup') popupElement!: ElementRef<HTMLDivElement>;
  private popup!: OlOverlay;

  hasrailprofiles: boolean = false;
  railprofiles: any = [];
  filtertrailprofiles: any = [];
  railprofilescolors: any = [];
  railprofilesOverlays: any = [];
  isProfielViewerVisible = false;
  profilDiaData: any = [];
  profilDiaHeader: any = [];
  ProfileViewRow: any;
  ProfileViewIndex: number = 0;
  setRailProfilesOn: boolean = false;
  isloadRecycle: boolean = false;
  zoomOutAfterRefresh: boolean = false;
  tempDisable: boolean = false;
  curColor: CurrentColor;
  protected unitLength: any;
  kilometrierung: boolean = false;

  originalFeatures: Feature<Point>[] = [];

  ol: InputInfo = { color: null, i: 0, j: 0, key: null };
  colorVal: string;

  profil = '';
  disfk_l = 0;
  disfk_r = 0;
  pos = 0;
  pos_m: string = '0';
  spur = 0;

  sumAnzahl: number = -1;
  sumLenght: number = -1;
  strTime: string = '';

  vauleGrinding = 1.5;
  optionsGrinding: Options = {
    floor: 0.5,
    ceil: 1.5,
    step: 0.1,
  };

  vauleGrindingSpeed = 15;
  optionsGrindingSpeed: Options = {
    floor: 5,
    ceil: 15,
    step: 1,
  };

  graphL = {
    show: true,
    id: 'plotly_Left',
    layout: {
      autosize: false,
      showlegend: false,
      width: 700,
      height: 700,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      yaxis: {
        range: [-80, 40],
        tick0: 0,
        dtick: 5,
      },
      xaxis: {
        range: [-60, 60],
        tick0: 0,
        dtick: 5,
      },
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d'],
    },
    data: [],
  };

  graphR = {
    id: 'plotly_Right',
    layout: {
      autosize: false,
      showlegend: false,
      width: 700,
      height: 700,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      yaxis: {
        range: [-80, 40],
        tick0: 0,
        dtick: 5,
      },
      xaxis: {
        range: [-60, 60],
        tick0: 0,
        dtick: 5,
      },
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d'],
    },
    data: [],
  };

  sliderGrindingEvent() {
    this.railprofilesOverlays = this.railprofilescolors[this.vauleGrinding];
    this.setGrindingTime();
  }

  vauleWare = 0.5;
  optionsWare: Options = {
    floor: 0.1,
    ceil: 10,
    step: 0.1,
  };

  objSetText(prop: any, obj: any) {
    if (this.showObjText && (prop.Name != null || prop.StammName != null)) {
      obj.setText(
        new OlText({
          text: prop.Name || prop.StammName,
          font: 'Arial bold',
          //offsetY: 12,
          //offsetX: 12,
          textAlign: 'center',
          justify: 'center',
          stroke: new OlStroke({ color: 'white', width: 6 }),

          scale: 1.6,
        })
      );
    } else {
      obj.setText(null);
    }
  }

  setGrindingTime() {
    let colnum = ((this.vauleGrinding * 10) / 100).toString().split('.')[1];
    if (colnum.length == 1) {
      colnum = colnum + '0';
    }

    let colAnz = 'NoP_GC_' + colnum;
    let colLen = 'Dis_GC_' + colnum;
    this.sumAnzahl = this.filtertrailprofiles.reduce((sum, row) => sum + +row[colAnz], 0).toFixed(1);
    this.sumLenght = this.filtertrailprofiles.reduce((sum, row) => sum + +row[colLen], 0).toFixed(1);
    let speed = this.vauleGrindingSpeed;
    let t = this.sumLenght / speed;
    this.strTime = t.toFixed(1) + ' minutes';

    if (t > 60) {
      let num = t;
      let hours = num / 60;
      let rhours = Math.floor(hours);
      let minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);

      this.strTime = rhours.toString() + ' hours, ' + rminutes.toString() + ' minute';
    }

    setTimeout(() => {});
  }

  sliderWareEvent() {
    this.setFilterSchienenprofile();
  }

  sliderGrindingSpeedEvent() {
    this.setGrindingTime();
  }

  setFilterSchienenprofile(all: boolean = false) {
    this.spinner.enable();
    this.visumode = ['railprofiles', 0];
    this.disableAllOverlays(this.visumode);
    if (all) this.setRailProfilesOn = true;
    this.railProfilesLayer.getSource().refresh();
  }

  setContextMenuClicked(bar: any) {
    let row = bar.row;
    if (row.FileNameLeft) {
      this.ProfileViewRow = row;
      this.apiservice
        .getRailProfilesSelected({ row })
        .pipe(first())
        .subscribe((val: any) => {
          if (val.success) {
            this.profilDiaData = val.data;
            this.profilDiaHeader = val.headers;
            this.ProfileViewIndex = 0;
            this.getDiaDataProfileView();
            this.isProfielViewerVisible = true;

            setTimeout(() => {
              Plotly.newPlot('plotly_Left', this.graphL.data, this.graphL.layout, this.graphL.config as any);
              Plotly.newPlot('plotly_Right', this.graphR.data, this.graphR.layout, this.graphR.config as any);
            }, 100);
          }
        });
    }
  }

  setBarMouseOver(bar: any) {
    let row = bar.row;
    let dat = bar.data;
    let src = this.topojsonLayer.getSource();

    if (this.selectedElement == undefined) {
      let ostammid = row.OSTAMMID;
      const features = this.topojsonLayer.getSource().getFeatures();
      const activeElement = features.find(feature => {
        const props = feature.getProperties();
        return props?.layername?.includes('objekttyp') && props.OSTAMMID == ostammid;
      });

      this.selectedElement = activeElement;
      src.addFeature(this.positionBarFeature);
    }

    if (this.selectedElement != undefined) {
      let pos = (row.StartPosition - dat.von).toString();
      let coord = this.selectedElement
        .getGeometry()
        .getCoordinateAt(parseFloat(pos) / geoDesLength(this.selectedElement.getGeometry()));

      const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36">
        <path fill="${row.color}" d="M18.9375 8C15.6275 8 12.9375 10.69 12.9375 14C12.9375 17.31 15.6275 20 18.9375 20C22.2475 20 24.9375 17.31 24.9375 14C24.9375 10.69 22.2475 8 18.9375 8ZM18.9375 18C16.7275 18 14.9375 16.21 14.9375 14C14.9375 11.79 16.7275 10 18.9375 10C21.1475 10 22.9375 11.79 22.9375 14C22.9375 16.21 21.1475 18 18.9375 18ZM18.9375 2C12.3175 2 6.9375 7.38 6.9375 14C6.9375 22.32 17.7675 33.25 18.2275 33.71C18.4275 33.91 18.6775 34 18.9375 34C19.1975 34 19.4475 33.9 19.6475 33.71C20.1075 33.25 30.9375 22.32 30.9375 14C30.9375 7.38 25.5575 2 18.9375 2ZM18.9375 31.55C16.5475 28.99 8.9375 20.35 8.9375 14C8.9375 8.49 13.4275 4 18.9375 4C24.4475 4 28.9375 8.49 28.9375 14C28.9375 20.35 21.3275 29 18.9375 31.55Z"/>
      </svg>`;

      const icon = new Icon({
        src: 'data:image/svg+xml;utf8,' + encodeURIComponent(svg),
        anchor: [0.5, 1],
        scale: 1,
      });

      this.positionStyle.setImage(icon);
      this.positionBarFeature.setStyle(this.positionStyle);
      this.positionBarFeature.setGeometry(coord ? new Point(coord) : null);
      let pnt = new Point(this.positionBarFeature.getGeometry().getExtent());
      this.map.getView().fit(pnt, { padding: [170, 50, 30, 150], minResolution: 6 });
    }
  }

  setBarMouseLeave(bar: any) {
    this.selectedElement = undefined;
    let src = this.topojsonLayer.getSource();
    src.removeFeature(this.positionBarFeature);
  }

  setBarclicked(bar: any) {
    let row = bar.row;
    let dat = bar.data;
    if (row.FileNameLeft) {
      this.ProfileViewRow = row;

      let ostammid = row.OSTAMMID;
      const features = this.topojsonLayer.getSource().getFeatures();
      const activeElement = features.find(feature => {
        const props = feature.getProperties();
        return props?.layername?.includes('objekttyp') && props.OSTAMMID == ostammid;
      });

      if (activeElement) {
        let pos = (row.StartPosition - dat.von).toString();
        let coordPoint = activeElement
          .getGeometry()
          .getCoordinateAt(parseFloat(pos) / geoDesLength(activeElement.getGeometry()));

        this.map.setView(
          new View({
            center: coordPoint,
            zoom: 16,
          })
        );
      }
    }
  }

  moveProfileView(dir: string) {
    if (dir == 'left') {
      this.ProfileViewIndex -= 1;
    } else {
      this.ProfileViewIndex += 1;
    }
    if (this.ProfileViewIndex < 0) {
      this.ProfileViewIndex = 0;
    }

    this.getDiaDataProfileView();
  }

  getDiaDataProfileView() {
    this.graphL.data = [];
    this.graphR.data = [];

    let filesL = this.ProfileViewRow.FileNameLeft.split('|');
    let filesr = this.ProfileViewRow.FileNameRight.split('|');

    if (this.ProfileViewIndex > filesL.length - 1) {
      this.ProfileViewIndex = filesL.length - 1;
    }

    let fileL = filesL[this.ProfileViewIndex];
    let fileR = filesr[this.ProfileViewIndex];
    let istl = [];
    let istr = [];

    let dh_l = 0;
    let dh_r = 0;

    let p0 = { x: [], y: [] };
    let p1 = { x: [], y: [] };

    Object.entries(this.profilDiaData).forEach(([key, value]) => {
      if (key.includes(fileL)) {
        this.profil = value['profil'];
        this.disfk_l = value['disfk'].toFixed(2);
        this.pos = value['pos'].toFixed(4);
        this.pos_m = (value['pos'].toFixed(3) * 1609.344).toFixed(2);
        this.spur = value['spur'];
        dh_l = value['dH'];

        p0.x.push(value['IntersecPointFk'].X);
        p0.y.push(value['IntersecPointFk'].Y);
        p0.x.push(value['IntersecPointHd'].X);
        p0.y.push(value['IntersecPointHd'].Y);

        let xy: any = [];
        xy = value['xy'];
        xy.forEach(werte => {
          let il = { x: [], y: [] };
          werte.forEach(element => {
            il.x.push(element.X);
            il.y.push(element.Y);
          });

          let tra = {
            x: il.x,
            y: il.y,
            mode: 'lines',
            name: 'Ist-Profil links',
            line: {
              color: 'rgb(37, 130, 197)',
              width: 3,
            },
          };

          istl.push(tra);
        });
      }

      if (key.includes(fileR)) {
        dh_r = value['dH'];
        this.disfk_r = value['disfk'].toFixed(2);

        p1.x.push(value['IntersecPointFk'].X);
        p1.y.push(value['IntersecPointFk'].Y);
        p1.x.push(value['IntersecPointHd'].X);
        p1.y.push(value['IntersecPointHd'].Y);

        let xy: any = [];
        xy = value['xy'];
        xy.forEach(werte => {
          let ir = { x: [], y: [] };
          werte.forEach(element => {
            ir.x.push(element.X);
            ir.y.push(element.Y);
          });

          let tra = {
            x: ir.x,
            y: ir.y,
            mode: 'lines',
            name: 'Ist-Profil links',
            line: {
              color: 'rgb(37, 130, 197)',
              width: 3,
            },
          };

          istr.push(tra);
        });
      }
    });

    Object.entries(this.profilDiaHeader).forEach(([key, value]) => {
      if (key == this.profil) {
        let xy: any = [];
        xy = value;
        let sl = { x: [], y: [] };
        let sr = { x: [], y: [] };
        xy.forEach(element => {
          sr.x.push(element.X);
          sr.y.push(element.Y - dh_r);

          sl.x.push(element.X * -1);
          sl.y.push(element.Y - dh_l);
        });

        let tra = {
          x: sr.x,
          y: sr.y,
          mode: 'lines',
          name: 'CPG-Profil rechts',
          line: {
            color: 'rgb(255, 0, 0)',
            width: 2,
          },
        };

        istr.push(tra);

        let tla = {
          x: sl.x,
          y: sl.y,
          mode: 'lines',
          name: 'CPG-Profil links',
          line: {
            color: 'rgb(255, 0, 0)',
            width: 2,
          },
        };

        istl.push(tla);
      }
    });

    let fk = {
      x: p0.x,
      y: p0.y,
      mode: 'scatter',
      name: 'ware',
      line: {
        color: 'rgb(152, 233, 112)',
        width: 1,
      },
    };

    istl.push(fk);

    let fkr = {
      x: p1.x,
      y: p1.y,
      mode: 'scatter',
      name: 'ware',
      line: {
        color: 'rgb(152, 233, 112)',
        width: 1,
      },
    };

    istr.push(fkr);

    this.graphL.data = istl;
    this.graphR.data = istr;

    if (this.isProfielViewerVisible) {
      setTimeout(() => {
        Plotly.newPlot('plotly_Left', this.graphL.data, this.graphL.layout, this.graphL.config as any);
        Plotly.newPlot('plotly_Right', this.graphR.data, this.graphR.layout, this.graphR.config as any);
      });
    }
  }

  showoverlay: boolean = false;
  showdetailview: boolean = false;
  hidedetailview: boolean = false;
  showprogressbar: boolean = false;
  prevangle = 0;
  rownr = 14;
  len: number = 0;
  lenSphere: number = 0;
  featLen: string = '0';
  curEPSG: string = 'EPSG:4326';
  split50 = false;
  sidenavenlarged = false;
  progressbarenlarged = false;
  canEdit: false;
  tblAnl: any;
  selTbl: any;
  baseColor: string = 'rgba(0,0,0,0.6)';
  hoverColor: string = '#fe5d00';
  hoverEmptyColor: string = '#FEAC88';
  tbChanged = computed(() => {
    console.log('something changed');
  });

  private readonly action: WritableSignal<actionT> = signal(undefined);
  private readonly drawType: WritableSignal<drawT> = signal(undefined);

  isObjLinkVisible = false;
  isALKISImportVisible = false;
  isFehlerFilterVisible = false;
  isTurnoutEditorVisible = false;
  isPositionModalVisible = false;
  isGeoPosModalVisible = false;
  isMapSetNameVisible = false;
  isnewMapSet = false;
  measure: any = {
    SetSecondPoint: false,
    Point1: {},
    Point2: {},
    Point1_Deg: {},
    Point2_Deg: {},
    PointX: '',
    PointY: '',
    Distance: '',
  };
  markers = [];
  arcShowDlgOnly = false;
  enableSave = false;
  altPressed = false;
  shiftPressed = false;
  selTOType = 0;
  selTOObject = '';
  curTOPic = '';
  lstWeichen: any;
  hasIntIDFound = false;

  curObjTyp = 0;
  curSymbol = '0';
  curMapSet: number = 1;
  selObjID = 0;
  tblObjektTypen: any;
  tblWeichenTypen: any;
  tblKartenset: any;
  progressbars: any;
  componentStore = {};
  tempInteractions = [];

  showObjText: boolean;
  showMangelBem: boolean;

  indexScrub: number = -1;
  overlayref;
  overlayZ = 3;
  overLayIds: any[] = [];
  baseLayer: any = [];
  drawInteractions: any = [];
  editInteractions: any = [];
  activeElement: any;
  selectedElement: any;

  selectedFeat: Feature;
  tempfeaturesList: any = [];
  protected readonly lstWeichenTypen: Record<number, string> = {
    0: 'EW - Einfache Weichen',
    1: 'Sym. ABW - Sym. Außenbogenweichen',
    2: 'ABW - Außenbogenweichen',
    3: 'EKW - Einfache Kreuzungsweichen',
    4: 'DKW - Doppelte Kreuzungsweichen',
    5: 'KR - Kreuzung',
  }; //,6:"IBW - Innenbogenweiche"
  prevTarget: any;
  mousepos: any;
  mouseposConv: any;
  dlgRadius: any;
  setPosFeatOnce: boolean = false;

  showOverlaySwitcher: boolean = false;
  isRep = this.apiservice.isRep;

  @ViewChild('fileInputALKIS') fileInputALKIS: ElementRef;
  @ViewChild('fileInputdxf') fileInputdxf: ElementRef;

  alkis_file_name: string = '';
  alkis_file: File = null;
  protected alkis: AlkisZuordnung[] = [];
  protected alkis_spez: AlkisAPI['spez'] = {};
  selectedformulare: any;
  hasAlkisHeader: boolean = false;
  runalkis: boolean = false;
  readonly #apiService = inject(APIService);
  protected readonly objekte = toSignal<SOTYP_Map>(this.#apiService.getSOTYP());
  protected otypid = signal<number>(undefined);
  uploadprocessrun: boolean = false;
  protected readonly uploadprocessprogress = signal(0);
  protected readonly spinnertitel = signal<string>(undefined);
  API_URL: string;
  jwt: string;
  alkis_fields = [
    'gemarkung_Land',
    'gemarkung_Nummer',
    'flurstuecksnummer',
    'flurstueckskennzeichen',
    'amtlicheFlaeche',
    'flurnummer',
    'flurstuecksfolge',
    'abweichenderRechtszustand',
    'zweifelhafterFlurstuecksnachweis',
    'rechtsbehelfsverfahren',
    'zeitpunktDerEntstehung',
    'gemeinde_Land',
    'gemeinde_Bezirk',
    'gemeinde_Kreis',
    'gemeinde',
    'gemeindeteil',
    'zustaendige_Stelle_Land',
    'zustaendige_Stelle',
    'eigentuemer_Name_Firma',
    'eigentuemer_Vorname',
    'eigentuemer_Ort',
    'eigentuemer_Plz',
    'eigentuemer_Strasse',
    'eigentuemer_Hausnummer',
    'buchungsblattkennzeichen',
    'buchungsblattnummerMitBuchstabenerweiterung',
  ];

  layers: any[] = [];

  vectorLayerNames = [
    'base',
    'objname',
    'points',
    'maengel.1',
    'maengel.2',
    'maengel.3',
    'maengel.4',
    'minfk.1',
    'minfk.2',
    'minfk.3',
    'minfk.4',
    'minfk.10',
  ];
  visuColors: any = {};
  features: any;

  objectFilter = [];
  datefilter: any = {
    vom: null,
    bis: null,
  };
  filter_invert = false;
  filter_modal = false;

  visumode;

  Featurecache = new Map<string, Feature[]>();
  ind: number = 0;

  public geolocation = new OlGeolocation({
    // enableHighAccuracy must be set to true to have the heading value.
    trackingOptions: {
      enableHighAccuracy: true,
    },
    //projection: this.map.view.getProjection(),
  });

  accuracyFeature = new Feature();

  positionBarFeature = new Feature();
  positionFeature = new Feature();
  positionCamFeature = new Feature();
  positionStyle = new OlStyle();
  drawarcFeature = new Feature();
  map: any;

  sqlfilter: any[] = [];
  filterSelection: any[] = [];
  filterWerte: any[] = [];
  filterWerteListe: any[] = [];
  filterItems: any[] = [];

  linieeorginal: any = [];
  _selectedLinienForObject: any = undefined;
  selected: any;

  modalFKFilter = new UntypedFormGroup({
    tabelle: new UntypedFormControl('', [Validators.required]),
    wert: new UntypedFormControl('', [Validators.required]),
    operators: new UntypedFormControl('', [Validators.required]),
  });

  modalAlkis = new UntypedFormGroup({
    schluessel: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
  });

  curentGeoJson: any;

  modalOpenShp = signal(false);
  selectedShpFile = signal<File | null>(null);
  selectedShpFileName = signal('');
  tblshpObjektTypen: any = [];
  curShpObjTyp = signal<number | null>(-1);
  lableShpSync = signal('');

  dbfFields = signal<
    Array<{
      name: string;
      type: string;
      length: number;
      decimals: number;
    }>
  >([]);

  matchRows = signal<MatchRow[]>([
    {
      shpField: null,
      mrField: null,
    },
  ]);

  modalShpLink = new UntypedFormGroup({
    objTyp: new UntypedFormControl('', [Validators.required]),
    Field: new UntypedFormControl('', [Validators.required]),
  });

  mrFields = signal(['ObjektId', 'Bezeichnung', 'Flaeche', 'Laenge']);

  stammdaten: any = [];

  openShpModal(): void {
    this.modalOpenShp.set(true);
    this.selectedShpFile.set(null);
    this.selectedShpFileName.set('');
    this.tblshpObjektTypen = [];
    this.tblshpObjektTypen.push({
      ID: 1,
      Name: 'MR.pro Objekt',
      Bezeichnung: this.mrTranslate.transform('MR.pro Objekt'),
      Typ: 1,
    });
    this.tblshpObjektTypen.push({
      ID: 1945,
      Name: 'Kilometrierung',
      Bezeichnung: this.mrTranslate.transform('Kilometrierung'),
      Typ: 1,
    });
    this.tblshpObjektTypen.push({
      ID: 0,
      Name: 'Undefiniert',
      Bezeichnung: this.mrTranslate.transform('Undefiniert'),
      Typ: 1,
    });

    this.apiservice
      .getStammdatenColumns()
      .pipe(first())
      .subscribe(data => {
        let r = data.rows;
        r.forEach(row => {
          row['Bezeichnung'] = this.mrTranslate.transform(row['Bezeichnung']);
        });
        r.sort((a, b) => a.Bezeichnung.localeCompare(b.Bezeichnung));

        r.splice(0, 0, { FeldName: 'EndMeter', Bezeichnung: 'EndMeter' });
        r.splice(0, 0, { FeldName: 'StartMeter', Bezeichnung: 'StartMeter' });
        r.splice(0, 0, { FeldName: 'Bezeichnung', Bezeichnung: 'Bezeichnung' });
        r.splice(0, 0, { FeldName: 'OSTAMMID', Bezeichnung: 'OSTAMMID' });

        this.stammdaten = r;
      });
  }

  closeShpModal(): void {
    this.modalOpenShp.set(false);
  }

  objShpTypChanged(val: number) {
    this.curShpObjTyp.set(val);
    if (val == 1945) {
      this.lableShpSync.set('Bezeichnung');
    } else {
      this.lableShpSync.set('Zuordnungsfeld');
    }
    setTimeout(() => {});
  }

  addRow(): void {
    this.matchRows.update(rows => [
      ...rows,
      {
        shpField: null,
        mrField: null,
      },
    ]);
  }

  removeRow(index: number): void {
    this.matchRows.update(rows => rows.filter((_, i) => i !== index));
  }

  updateShp(index: number, value: string): void {
    this.matchRows.update(rows => rows.map((row, i) => (i === index ? { ...row, shpField: value } : row)));
  }

  updateMr(index: number, value: string): void {
    this.matchRows.update(rows => rows.map((row, i) => (i === index ? { ...row, mrField: value } : row)));
  }

  hasDuplicates = computed(() =>
    this.matchRows().some(
      (row, index) => this.isDuplicateShp(row.shpField, index) || this.isDuplicateMr(row.mrField, index)
    )
  );

  isDuplicateShp(value: string | null, currentIndex: number): boolean {
    if (!value) {
      return false;
    }

    return this.matchRows().filter((row, index) => index !== currentIndex && row.shpField === value).length > 0;
  }

  isDuplicateMr(value: string | null, currentIndex: number): boolean {
    if (!value) {
      return false;
    }

    return this.matchRows().filter((row, index) => index !== currentIndex && row.mrField === value).length > 0;
  }

  async onShpFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      const zipFile = input.files[0];

      this.selectedShpFile.set(zipFile);
      this.selectedShpFileName.set(zipFile.name);

      try {
        const dbfBuffer = await this.extractDbfFromZip(zipFile);

        if (!dbfBuffer) {
          console.error('Keine DBF-Datei im ZIP gefunden.');
          return;
        }

        const fields = this.readDbfHeader(dbfBuffer);
        this.dbfFields.set(fields);
      } finally {
        input.value = '';
      }
    }
  }

  importShpFile() {
    const file = this.selectedShpFile();
    let m = this.matchRows();
    let mrFieldsString = this.matchRows()
      .map(row => row.mrField)
      .filter((field): field is string => field !== null)
      .join(', ');

    let fileReader = new FileReader();

    const rows = this.matchRows();
    const stammDatenMap = new Map<string, number>();

    let jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
    jsZip.loadAsync(file).then(zip => {
      Object.keys(zip.files).forEach(filename => {
        if (filename.includes('.prj')) {
          jsZip.remove(filename);
        }
      });
      zip.generateAsync({ type: 'blob' }).then(z => {
        fileReader.readAsArrayBuffer(z);
      });
    });

    if (this.curShpObjTyp() == 0 || this.curShpObjTyp() == 1945) {
      mrFieldsString = 'Bezeichnung';
    }

    fileReader.onload = (e: any) => {
      this.spinner.enable();
      this.apiservice
        .getStammDatenMap(mrFieldsString)
        .pipe()
        .subscribe((res: any) => {
          for (const item of res.rows) {
            const key = rows.map(row => item[row.mrField!] ?? '__NULL__').join('|');

            if (key.includes(';')) {
              let keys = key.split(';');
              keys.forEach(k => {
                stammDatenMap.set(k, item.OSTAMMID);
              });
            } else {
              stammDatenMap.set(key, item.OSTAMMID);
            }
          }

          shp(fileReader.result).then(e => {
            e.features.forEach(fCol => {
              let src = this.topojsonLayer.getSource();
              const features: any = new OlTopoJSON().readFeatures(fCol);
              features.forEach(feat => {
                if (feat.values_.geometry) {
                  const geom = feat.getGeometry();
                  geom.transform(this.curEPSG, 'EPSG:3857');

                  this.cleanGeometry(geom, 1.0);

                  //feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
                  feat.setProperties({ layername: 'objekttyp.0' });
                  if (feat.getGeometry().getType() == 'Point') {
                    feat.setProperties({ PointID: '0' });
                  }

                  const key = rows.map(row => String(feat.get(row.shpField!))).join('|');
                  const ostammid = stammDatenMap.get(key);

                  if (ostammid !== undefined) {
                    feat.setProperties({
                      OSTAMMID: ostammid,
                    });
                  }

                  if (this.curShpObjTyp() == 1945) {
                    feat.setProperties({
                      TYPID: 1945,
                      NAME: feat.values_[this.modalShpLink.controls.Field.value],
                    });
                  }

                  this.tempfeaturesList.push({
                    type: 'import_Line',
                    feature: feat,
                    geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
                  });
                }
              });
              src.addFeatures(features);
              this.enableSave = true;
              this.topojsonLayer.setStyle(this.getLayerStyles());
              this.toastr.success(this.mrTranslate.transform('Daten importiert'));
              this.spinner.disable();
            });
          });
        });
    };
  }

  cleanGeometry(geometry: Geometry, minDistance = 1): Geometry {
    const filterCoords = (coords: number[][]): number[][] => {
      if (coords.length <= 2) {
        return coords;
      }

      const result: number[][] = [coords[0]];
      let last = coords[0];

      for (let i = 1; i < coords.length - 1; i++) {
        const current = coords[i];

        const dx = current[0] - last[0];
        const dy = current[1] - last[1];
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist >= minDistance) {
          result.push(current);
          last = current;
        }
      }

      result.push(coords[coords.length - 1]);

      return result;
    };

    switch (geometry.getType()) {
      case 'LineString': {
        const geom = geometry as LineString;
        geom.setCoordinates(filterCoords(geom.getCoordinates()));
        return geom;
      }

      case 'Polygon': {
        const geom = geometry as Polygon;
        geom.setCoordinates(geom.getCoordinates().map(ring => filterCoords(ring)));
        return geom;
      }

      default:
        return geometry;
    }
  }

  readDbfHeader(buffer: ArrayBuffer) {
    const view = new DataView(buffer);

    const headerLength = view.getUint16(8, true);

    const fields = [];
    let offset = 32;

    while (offset < headerLength - 1) {
      const nameBytes = new Uint8Array(buffer, offset, 11);

      const name = new TextDecoder().decode(nameBytes).replace(/\0/g, '').trim();

      const type = String.fromCharCode(view.getUint8(offset + 11));
      const length = view.getUint8(offset + 16);
      const decimals = view.getUint8(offset + 17);

      fields.push({
        name,
        type,
        length,
        decimals,
      });

      offset += 32;
    }

    return fields;
  }

  async extractDbfFromZip(zipFile: File): Promise<ArrayBuffer | null> {
    const zipBuffer = await zipFile.arrayBuffer();
    const zip = await JSZip.loadAsync(zipBuffer);

    const dbfEntry = Object.values(zip.files).find(file => file.name.toLowerCase().endsWith('.dbf'));

    if (!dbfEntry) {
      return null;
    }

    return await dbfEntry.async('arraybuffer');
  }

  //Filter Objekte verknüpfen
  tableUniqueColumnValues: Record<string, Set<any>>;
  tableIconColumnValues: Map<string, number>;
  filterService: FilterService;
  filteredRows: any[];
  @ViewChildren(ColumnFilterComponent)
  columnFilters: QueryList<ColumnFilterComponent>;

  private setFilters() {
    this.tableUniqueColumnValues = getUniqueValues(this.tblAnl);
    this.tableIconColumnValues = getTypeIconCombination(this.tblAnl);
    this.filterService ??= new FilterService();
    this.filterService.originalData = this.tblAnl.rows;

    const filterApplied =
      this.filterService.isAktiv ? this.filterService.filters : JSON.parse(sessionStorage.getItem('filtergismap'));

    this.filterService.filters = filterApplied;
    this.filteredRows = this.filterService.filteredData;

    setTimeout(() => {
      if (filterApplied) {
        const filterKeys = Object.keys(filterApplied);
        if (filterKeys.length > 0) {
          sessionStorage.removeItem('filtergismap');
          for (const filter of this.columnFilters) {
            const column = filter.column();
            const filterInd = filterKeys.indexOf(column?.id);
            if (filterInd != -1) {
              filter.restoreFilter(filterApplied[column.id]);
              filterKeys.splice(filterInd, 1);
              if (filterKeys.length == 0) break;
            }
          }
        }
      }
    }, 100);
  }

  getUniqueValuesForColumn(tableValues: Record<string, Set<any>>, columnId: string): Set<any> {
    return tableValues[columnId] || new Set();
  }

  onFilterChange(columnFilterChange: ColumnFilterChange) {
    this.filteredRows = this.filterService.filter(columnFilterChange);
  }

  // Ende Filter

  public setGisPos(event) {
    let src: OlVectorSource = this.modPointsLayer.getSource();
    if (event == -98000) {
      src.removeFeature(this.positionCamFeature);
      return;
    }
    let coordPoint = this.activeElement
      .getGeometry()
      .getCoordinateAt(parseFloat(event) / geoDesLength(this.activeElement.getGeometry()));

    if (!src.hasFeature(this.positionCamFeature)) src.addFeature(this.positionCamFeature);
    this.modPointsLayer.setStyle(this.getLayerStyles());

    this.positionCamFeature.setGeometry(new Point(coordPoint));
    this.positionCamFeature.setStyle(
      new OlStyle({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: 'green',
          }),
          stroke: new OlStroke({
            color: 'green',
            width: 2,
          }),
        }),
        zIndex: 6,
      })
    );
  }

  loadLinien() {
    if (this.linieeorginal.length != 0) return;

    let linie = {
      status: 'get',
    };

    this.apiservice
      .sendKLINIEN({ linie })
      .pipe(first())
      .subscribe((val: any) => {
        if (val.klinien.rows != 0) {
          this.linieeorginal = val.klinien.rows;
        }
      });
  }
  set selectedLinienForObject(newVal: any) {
    this._selectedLinienForObject = newVal;
  }

  get selectedLinienForObject(): any {
    return this._selectedLinienForObject;
  }

  addLine() {
    let linieid = this._selectedLinienForObject;
    let linie = {
      status: 'addobjekttoline',
      id: parseInt(linieid),
      ostammid: [this._ostammid],
    };

    this.apiservice
      .sendKLINIEN({ linie })
      .pipe(first())
      .subscribe((val: any) => {
        if (val) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        }
      });
  }

  delete(item) {
    const index: number = this.sqlfilter.indexOf(item);
    if (index !== -1) {
      this.sqlfilter.splice(index, 1);
    }

    this.getFilterItems();

    Object.keys(this.overLayers.base[2].overlays).forEach(id => {
      this.changeOverlayState('base', 2, parseInt(id), 0);
    });

    if (this.sqlfilter.length != 0) {
      setTimeout(() => {
        this.setFilter();
      }, 700);
    }
  }

  addFilter() {
    this.modalFKFilter.markAllAsTouched();

    if (this.modalFKFilter.valid) {
      let operator = ' = ';
      if (this.modalFKFilter.value.operator == '1') {
        operator = ' like ';
      }

      let anzeige = '';
      let tabelle = '';
      let feld = '';
      Object.keys(this.filterSelection).forEach(id => {
        if (id == this.modalFKFilter.value.tabelle) {
          anzeige = this.filterSelection[id].anzeige;
          tabelle = this.filterSelection[id].tabelle;
          feld = this.filterSelection[id].feld;
        }
      });

      let items = {
        sql: anzeige + operator + this.modalFKFilter.value.wert,
        operators: operator,
        wert: this.modalFKFilter.value.wert,
        tabelle: tabelle,
        feld: feld,
      };

      this.sqlfilter.push(items);
      this.modalFKFilter.reset();
      this.modalFKFilter.controls.operators.setValue(0);

      this.getFilterItems();
    }
  }

  initFilter() {
    this.modalFKFilter.controls.operators.setValue(0);
    this.isFehlerFilterVisible = true;
    this.apiservice
      .getFKFilter()
      .pipe(first())
      .subscribe((result: any) => {
        this.filterSelection = result['felder'].sort((a, b) => a.anzeige.localeCompare(b.anzeige));
        this.filterWerte = result['werte'];
      });

    Object.keys(this.overLayers.base[2].overlays).forEach(id => {
      this.changeOverlayState('base', 2, parseInt(id), 0);
    });
  }

  setFilterWerte(obj: any) {
    this.filterWerteListe = [];
    let feld = '';
    let tabelle = '';
    Object.keys(this.filterSelection).forEach(id => {
      if (id == obj) {
        feld = this.filterSelection[id].feld;
        tabelle = this.filterSelection[id].tabelle;
      }
    });
    this.filterWerteListe = this.filterWerte[tabelle + '.' + feld].sort((a, b) => a.localeCompare(b));
  }

  activateFilter() {
    this.setFilter();
    this.isFehlerFilterVisible = false;
  }

  cancelFilter() {
    this.sqlfilter = [];
    this.filterItems = [];
    this.isFehlerFilterVisible = false;
    this.setFilter();
  }

  setFilter() {
    Object.keys(this.overLayers.base[2].overlays).forEach(id => {
      this.changeOverlayState('base', 2, parseInt(id), 1);
    });
  }

  getFilterItems() {
    if (this.sqlfilter.length == 0) {
      this.filterItems = [];
      return;
    }

    this.apiservice
      .getFKFilterItems(this.sqlfilter)
      .pipe(first())
      .subscribe((result: any) => {
        this.filterItems = result.OMAZSIDs;
      });
  }

  topojsonLayer: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({
      overlaps: false,
      format: new OlTopoJSON(),
      loader: async (extent, resolution, projection) => {
        const src = this.topojsonLayer.getSource();
        const srcp: OlVectorSource = this.polygonLayer.getSource();

        try {
          src.clear();
          srcp.clear();

          //Lade vom IndexedDB oder alte Variante
          const x: FeatureCollection =
            (await dbS.getGIS(localStorage.getItem('DB') + this.curMapSet)) ?? (await this.apiservice.getTopoJson());

          let fCol: FeatureCollection = {
            features: x.features.filter(f => f.geometry.type != 'Polygon'),
            type: 'FeatureCollection',
          };
          let features = src.getFormat().readFeatures(fCol, {
            featureProjection: 'EPSG:3857',
          });
          src.addFeatures(features);

          fCol.features = x.features.filter(f => f.geometry.type == 'Polygon');
          features = srcp.getFormat().readFeatures(fCol, {
            featureProjection: 'EPSG:3857',
          });
          srcp.addFeatures(features);

          this.topojsonready$.next(true);
          if (this.zoomOutAfterRefresh) {
            this.zoomOutAfterRefresh = false;
            this.map.getView().fit(this.topojsonLayer.getSource().getExtent(), {
              duration: 500,
              padding: [50, 50, 50, 50],
              callback: () => {
                this.mapZoomed$.next(true);
              },
            });
          }
        } catch (er) {
          src.removeLoadedExtent(extent);
          srcp.removeLoadedExtent(extent);
        }
        return this.features;
      },
    }),
    style: this.getLayerStyles(),
  });

  gleisMessFilter: any = [];
  isGleisMessFilterReady = false;

  posLayer: OlVectorLayer<any>;
  posBarLayer: OlVectorLayer<any>;

  importLayer: OlVectorSource<any>;
  drawVector: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({ wrapX: false }),
  });
  modPointsLayer: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({ wrapX: false }),
    style: this.modPointStyleFunction(),
  });
  polygonLayer: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({ wrapX: false, format: new OlTopoJSON() }),
    style: this.getLayerStyles(),
  });

  railProfilesLayer: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({
      overlaps: false,
      format: new OlTopoJSON(),
      loader: (extent, resolution, projection) => {
        if (this.railprofiles.length > 0) {
          this.filtertrailprofiles = this.railprofiles.filter(
            row => row['disfkL'] >= this.vauleWare || row['disfkR'] >= this.vauleWare
          );

          this.railProfilesLayer.getSource().removeLoadedExtent(extent);

          let geojsonObject = {
            type: 'FeatureCollection',
            features: [],
          };

          this.filtertrailprofiles.forEach((key: any) => {
            let feat = JSON.parse(key['geometry']);
            Object.entries(key).forEach((x: [string, any]) => {
              if (x[0] != 'geometry') feat.properties[x[0]] = x[1];
            });
            geojsonObject['features'].push(feat);
          });

          let src = this.railProfilesLayer.getSource();

          setTimeout(() => {
            let features = src.getFormat().readFeatures(geojsonObject, {
              featureProjection: 'EPSG:3857',
            });
            src.addFeatures(features);

            this.spinner.disable();
            this.sliderGrindingEvent();
            this.getLayerStyles();
            if (this.setRailProfilesOn)
              for (let i = 0; i < this.railprofilesOverlays.length; i++) {
                this.railprofilesOverlays[i].enable = true;
                this.setRailProfilesOn = false;
              }
            else
              for (let i = 0; i < this.railprofilesOverlays.length; i++) {
                this.changeOverlayState('railprofiles', 0, i, this.railprofilesOverlays[i].enable, true);
              }
          });
        } else {
          this.spinner.disable();
        }
      },
    }),
    style: (feature, resolution) => {
      if (feature.getProperties()['layername']?.includes('railprofiles')) {
        this.elementStyles.line.getStroke().setColor(feature.getProperties()['color']);
        this.elementStyles.line.getStroke().setLineDash([]);
        return this.elementStyles.line;
      }
    },
  });

  gleisMessLayer: OlVectorLayer<any> = new OlVectorLayer({
    source: new OlVectorSource({
      overlaps: false,
      format: new OlTopoJSON(),
      loader: (extent, resolution, projection) => {
        if (this.gleisMessFilter.length > 0) {
          let xhr = new XMLHttpRequest();
          let token = localStorage.getItem('jwt');
          xhr.open('POST', environment.apiUrl + '/karte/gleismessdaten', true);
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
          xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
          xhr.setRequestHeader('Cache-Control', 'no-store');

          let onError = () => {
            this.gleisMessLayer.getSource().removeLoadedExtent(extent);
          };
          xhr.onerror = onError;
          xhr.onload = () => {
            if (xhr.status == 200) {
              let src = this.gleisMessLayer.getSource();
              setTimeout(() => {
                let features = src.getFormat().readFeatures(xhr.responseText, {
                  featureProjection: 'EPSG:3857',
                });
                src.addFeatures(features);
                this.spinner.disable();
                this.isGleisMessFilterReady = true;
              });
            } else {
              this.isGleisMessFilterReady = true;
              onError();
            }
          };
          xhr.send(JSON.stringify(this.gleisMessFilter));
        } else {
          this.spinner.disable();
          this.isGleisMessFilterReady = true;
        }
      },
    }),
    style: () => {
      this.elementStyles.line.getStroke().setColor('red');
      this.elementStyles.line.getStroke().setLineDash([]);
      return this.elementStyles.line;
    },
  });

  tileLayers = TileLayerObj;
  elementStyles = ElementStylesObj;

  overLayers: any = {
    base: [
      {
        category: 'Base Overlays',
        overlays: [],
      },
      {
        category: 'Fehlerklassen einfach',
        overlays: [
          {
            name: ' FK 1',
            key: 'minfk.1',
            enable: false,
            color: 'red',
          },
          {
            name: ' FK 2',
            key: 'minfk.2',
            enable: false,
            color: 'yellow',
          },
          {
            name: ' FK 3',
            key: 'minfk.3',
            enable: false,
            color: 'green',
          },
          {
            name: ' FK 4',
            key: 'minfk.4',
            enable: false,
            color: 'blue',
          },
          {
            name: ' ohne Mängel',
            key: 'minfk.10',
            enable: false,
            color: '#030303',
          },
        ],
      },
      {
        category: 'Fehlerklassen segmentiert',
        overlays: [
          {
            name: ' FK 1',
            key: 'maengel.1',
            enable: false,
            color: 'red',
          },
          {
            name: ' FK 2',
            key: 'maengel.2',
            enable: false,
            color: 'yellow',
          },
          {
            name: ' FK 3',
            key: 'maengel.3',
            enable: false,
            color: 'green',
          },
          {
            name: ' FK 4',
            key: 'maengel.4',
            enable: false,
            color: 'blue',
          },
        ],
      },
    ],
    visualisations: {},
  };

  overLayersOriginal = duplicate(this.overLayers);

  draw: Draw; // global so we can remove it later
  snap: any;

  clickSelect: any;
  clickSelectLenght: any;
  hoverSelect: any;
  multiSelect: any;

  modify: any;
  Object = Object;

  subscriptions: Subscription[] = [];

  @ViewChild('datagridwrapper', { static: true }) datagridwrapper: ElementRef;

  mapready$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  topojsonready$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  activeElement$ = new BehaviorSubject<Feature<Geometry>>(undefined);
  mapZoomed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  doreloadTopoJson: boolean = false;

  constructor() {
    this.railprofilesOverlays = [];
    this.curMapSet = parseInt(localStorage.getItem('karteFileID')) ?? 1;

    // subscribe to when mapready and topojsonready are both true
    combineLatest([this.mapready$, this.topojsonready$, this.activeElement$])
      .pipe(
        filter(([mapready, topojsonready, activeElement]) => {
          return mapready && topojsonready && activeElement !== undefined;
        }),
        take(1)
      )
      .subscribe(() => {
        this.selectFeature(this.activeElement$.getValue());
      });

    const ref = effect(() => {
      if (this.otypid() === undefined) {
        for (const id in this.objekte()) {
          this.otypid.set(+id);
          break;
        }
      } else ref.destroy();
    });
  }

  private isInitialChange = true;
  protected allObjSelected = ClrSelectedState.INDETERMINATE;

  protected selectAlleObjekte(state: ClrSelectedState | '') {
    if (state == '') return;
    this.allObjSelected = state;

    if (state == ClrSelectedState.INDETERMINATE) return;

    if (this.isInitialChange) {
      this.isInitialChange = false;
      return;
    }

    for (let i = 1; i < this.overLayers.base[0].overlays.length; i++) {
      this.changeOverlayState('base', 0, i, this.allObjSelected);
    }
  }

  private updateMapSize() {
    this.map.updateSize();
    window.dispatchEvent(new Event('resize'));
  }

  addInteraction(type: string) {
    let value = type;
    if (value !== 'None') {
      this.draw = new Draw({
        source: this.drawVector.getSource(),
        type: <Type>type,
      });

      this.draw.on('drawabort', e => {
        this.action.set('');
        this.map.removeInteraction(this.draw);
      });

      this.draw.on('drawend', e => {
        let isPolygon: boolean = this.drawType() == 'Circle' || this.drawType() == 'Polygon';
        this.action.set('');
        if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
        this.prevTarget = undefined;
        this.map.removeInteraction(this.draw);
        e.feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');

        let c: any = {};
        c.koordinaten = (e.feature as Feature<LineString>).getGeometry().getCoordinates();
        c.typid = isPolygon ? 6 : 1;
        this.map.getViewport().style.cursor = 'grab';
        this.apiservice
          .setNewFeature(c)
          .pipe()
          .subscribe((res: any) => {
            let src = this.topojsonLayer.getSource();
            let features = src.getFormat().readFeature(res, {
              featureProjection: 'EPSG:3857',
            });
            this.tempfeaturesList.push({ type: 'new_Line', feature: res });
            src.addFeature(features);
            this.enableSave = true;
          });
      });

      if (this.editInteractions.length == 0) {
        this.editInteractions = this.map.interactions.array_;
      }

      this.map.removeInteraction('Draw');
      this.map.removeInteraction('Snap');
      this.map.interactions.push(this.draw);
      this.snap = new Snap({
        source: this.topojsonLayer.getSource(),
      });
      this.map.addInteraction(this.snap);
    }
  }

  startDraw(type: drawT, event: any) {
    this.action.set('draw');
    this.drawType.set(type);
    this.map.getViewport().style.cursor = 'crosshair';
    if (this.prevTarget === event.currentTarget || type == 'None') {
      this.action.set('');
      if (type == 'None') this.prevTarget.style.backgroundColor = '#F0F0F0';
      this.prevTarget = undefined;
      event.currentTarget.style.backgroundColor = '#F0F0F0';
      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.snap);
      this.addInteraction('None');
      return;
    }
    if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
    event.currentTarget.style.backgroundColor = '#9E9E9E';
    this.prevTarget = event.currentTarget;

    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.snap);
    this.addInteraction(type);
  }
  startDrawArc(showonlyDialog: any, event: any) {
    this.map.getViewport().style.cursor = 'crosshair';
    if (this.action() != 'drawarc') {
      if (this.action() == 'draw') {
        this.draw.abortDrawing();
      }
      this.arcShowDlgOnly = showonlyDialog;
      this.action.set('drawarc');
      this.markers = [];
      this.drawarcFeature = undefined;

      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;
    } else {
      this.action.set('');
      this.arcShowDlgOnly = false;
      let src = this.topojsonLayer.getSource();
      src.removeFeature(this.drawarcFeature);
      this.prevTarget.style.backgroundColor = '#F0F0F0';
    }
  }
  startPlaceSymbol(type: number, event: any) {
    this.action.set('place');
    this.map.getViewport().style.cursor = 'crosshair';
    this.curSymbol = type.toString();
    if (this.prevTarget === event.currentTarget) {
      this.action.set('');
      this.prevTarget = undefined;
      event.currentTarget.style.backgroundColor = '#F0F0F0';
      this.map.getViewport().style.cursor = 'grab';
      return;
    }
    if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
    event.currentTarget.style.backgroundColor = '#9E9E9E';
    this.prevTarget = event.currentTarget;
  }

  updateSelected(e: any) {
    if (this.activeElement) {
      this.isObjLinkVisible = true;
    } else {
      this.toastr.warning(this.mrTranslate.transform('Kein Objekt ausgewählt'));
    }
  }

  showTOEditor() {
    this.isTurnoutEditorVisible = true;
    this.modalTOEditor.controls.richtung.setValue(0);
    this.modalTOEditor.controls.WeichenTyp.setValue(0);
    setTimeout(() => {
      if (sessionStorage.getItem('weditTOObject') && sessionStorage.getItem('weditTOObjectType')) {
        this.modalTOEditor.controls.WeichenTyp.setValue(sessionStorage.getItem('weditTOObjectType'));
        this.modalTOEditor.controls.Bezeichnung.setValue(sessionStorage.getItem('weditTOObject'));
        this.getTOData(sessionStorage.getItem('weditTOObjectType'), true);
        this.setTOTypes(sessionStorage.getItem('weditTOObject'));
      } else {
        this.getTOData('0');
        this.modalTOEditor.controls.Bezeichnung.setValue('EW 50-1:3,25');
      }
    }, 200);
  }

  getTOData(value: any, fromNew: boolean = false) {
    this.selTOType = value;
    this.apiservice
      .getTOEdit(value)
      .pipe()
      .subscribe((res: any) => {
        if (res) {
          this.tblWeichenTypen = res;
          this.tb4Style.set('display:none');
          this.tb6Style.set('display:none');
          this.lstWeichen = [];
          this.curTOPic = 'assets/icons/Weicheneditor/';
          switch (value) {
            case '0':
              this.curTOPic += 'EW_L.png';
              this.lstWeichen.push(
                'EW 50-1:3,25',
                'EW 100-1:5',
                'EW 140-1:6',
                'EW 190-1:9',
                'EW 150-1:6.6',
                'EW 190-1:6.6',
                'EW 300-1:9',
                'EW 500-1:12',
                'EW 760-1:14',
                'EW 1200-1:18,5'
              );
              this.tb1Style.set('top:280px;left:250px');
              this.tb2Style.set('top:313px;left:250px');
              this.tb3Style.set('top:313px;left:400px');
              this.tb4Style.set('top:440px;left:350px');
              this.tb5Style.set('top:313px;left:500px;display:');
              break;
            case '1':
              this.curTOPic += 'ABW_L.png';
              this.lstWeichen.push('ABW 140-1:7', 'ABW 200-1:9');
              this.tb1Style.set('top:270px;left:300px');
              this.tb2Style.set('top:330px;left:230px');
              this.tb3Style.set('top:313px;left:360px');
              this.tb4Style.set('top:450px;left:350px;display:none');
              this.tb5Style.set('top:370px;left:550px;display:');
              break;
            case '2':
              this.curTOPic += 'ABW_L.png';
              this.lstWeichen.push('ABW 140-1:7', 'ABW 200-1:9');
              this.tb1Style.set('top:270px;left:300px');
              this.tb2Style.set('top:330px;left:230px');
              this.tb3Style.set('top:313px;left:360px');
              this.tb4Style.set('top:450px;left:350px');
              this.tb5Style.set('top:370px;left:550px;display:');
              this.tb6Style.set('top:450px;left:550px;display:');
              break;
            case '3':
              this.curTOPic += 'EKW_Vignol.png';
              this.lstWeichen.push('EKW 100-1:6', 'EKW 140-1:7', 'EKW 190-1:9');
              this.tb1Style.set('top:300px;left:280px');
              this.tb2Style.set('top:330px;left:380px');
              this.tb3Style.set('top:460px;left:263px');
              this.tb4Style.set('top:400px;left:560px;display:none');
              this.tb5Style.set('top:380px;left:560px;display:');
              break;
            case '4':
              this.curTOPic += 'DKW_Vignol.png';
              this.lstWeichen.push('DKW 100-1:6', 'DKW 140-1:7', 'DKW 190-1:9');
              this.tb1Style.set('top:300px;left:280px');
              this.tb2Style.set('top:330px;left:380px');
              this.tb3Style.set('top:460px;left:263px');
              this.tb4Style.set('top:380px;left:560px');
              this.tb5Style.set('display:none');
              break;
            case '5':
              this.curTOPic += 'Kr.png';
              this.lstWeichen.push(
                'Regel Kr 1:2,917',
                'Regel Kr 1:3,429',
                'Regel Kr 1:4,444',
                'Regel Kr 1:6',
                'Regel Kr 1:7',
                'Regel Kr 1:9',
                'Meter Kr 1:2,917',
                'Meter Kr 1:3,429',
                'Meter Kr 1:4,444',
                'Meter Kr 1:6',
                'Meter Kr 1:7',
                'Meter Kr 1:9'
              );
              this.tb1Style.set('top:300px;left:280px');
              this.tb2Style.set('top:330px;left:380px');
              this.tb3Style.set('top:460px;left:263px');
              this.tb4Style.set('top:380px;left:560px');
              this.tb5Style.set('display:none');
              break;
            case '6':
              this.curTOPic += 'EW_L.png';
              this.lstWeichen.push(
                'EW 50-1:3,25',
                'EW 100-1:5',
                'EW 140-1:6',
                'EW 190-1:7',
                'EW 300-1:9',
                'EW 500-1:12',
                'EW 760-1:14',
                'EW 1200-1:18,5',
                'EW 50-1:6',
                'EW 100-1:6',
                'EW 100-1:7',
                'EW 140-1:7',
                'EW 190-1:9'
              );
              this.tb1Style.set('top:380px;left:330px');
              this.tb2Style.set('top:260px;left:463px');
              this.tb3Style.set('top:560px;left:400px');
              this.tb4Style.set('top:380px;left:560px');
              this.tb5Style.set('display:none');
              break;
            case '7':
              //this.lstWeichen.push("DKW 100-1:6", "DKW 140-1:7", "DKW 190-1:9"]);
              break;
            default:
              break;
          }
          this.tblWeichenTypen.rows.forEach(rw => {
            this.lstWeichen.push(rw['Bezeichnung']);
          });
          if (!sessionStorage.getItem('weditTOObject') || !fromNew) this.setTOTypes(this.lstWeichen[0]);
        }
      });
  }

  setTOTypes(event: any) {
    this.selTOObject = event;
    sessionStorage.setItem('weditTOObject', event);
    sessionStorage.setItem('weditTOObjectType', this.selTOType.toString());
    this.apiservice
      .getTOEditSchiene(this.selTOType.toString(), event)
      .pipe()
      .subscribe((res: any) => {
        if (res) {
          if (res.rows.length > 0) {
            let rw = res.rows[0];
            this.tb1.set(rw.Value1);
            this.tb2.set(rw.Value2);
            this.tb3.set(rw.Value3);
            this.tb4.set(rw.Value4);
            this.tb5.set(rw.Value5);
            this.tb6.set(rw.Value6);
            return;
          }
        }
      });
    switch (event) {
      case 'EW 50-1:3,25':
        this.tb1.set('15036');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('2211');
        break;

      case 'EW 100-1:5':
        this.tb1.set('19804');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1942');
        break;
      case 'EW 140-1:6':
        this.tb1.set('23174');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1905');
        break;
      case 'EW 190-1:9':
        if (this.selTOType < 5) {
          this.tb1.set('27006');
          this.tb2.set((parseInt(this.tb1()) / 2).toString());
          this.tb3.set(this.tb2());
          this.tb4.set(this.tb2());
          this.tb5.set('1910');
        } else {
          this.tb1.set('27138');
          this.tb2.set('10523');
          this.tb3.set('16615');
          this.tb4.set('16615');
          this.tb5.set('1838');
        }
        break;
      case 'EW 150-1:6.6':
        this.tb1.set('26980');
        this.tb2.set('11299');
        this.tb3.set('15681');
        this.tb4.set('15681');
        this.tb5.set('2356');
        break;
      case 'EW 190-1:6.6':
        this.tb1.set('30039');
        this.tb2.set('14312');
        this.tb3.set('15020');
        this.tb4.set('15020');
        this.tb5.set('2363');
        break;
      case 'EW 300-1:9':
        this.tb1.set('33230');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1942');
        break;
      case 'EW 500-1:12':
        this.tb1.set('41594');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1727');
        break;
      case 'EW 760-1:14':
        this.tb1.set('54216');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1931');
        break;
      case 'EW 1200-1:18,5':
        this.tb1.set('64818');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1748');
        break;
      case 'Regel Kr 1:2,917':
        this.tb1.set('13440');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('2210');
        this.tb5.set('332');
        break;
      case 'Regel Kr 1:3,429':
        this.tb1.set('15420');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('2181');
        this.tb5.set('308');
        break;
      case 'Regel Kr 1:4,444':
        this.tb1.set('21366');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('2359');
        this.tb5.set('261');
        break;
      case 'Meter Kr 1:2,917':
        this.tb1.set('10842');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1782');
        this.tb5.set('293');
        break;
      case 'Meter Kr 1:3,429':
        this.tb1.set('12390');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1752');
        this.tb5.set('248');
        break;
      case 'Meter Kr 1:4,444':
        this.tb1.set('17470');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1929');
        this.tb5.set('213');
        break;
      case 'Meter Kr 1:6':
        this.tb1.set('16344');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1348');
        this.tb5.set('111');
        break;
      case 'Meter Kr 1:7':
        this.tb1.set('18890');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1339');
        this.tb5.set('95');
        break;
      case 'Meter Kr 1:9':
        this.tb1.set('24292');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1343');
        this.tb5.set('74');
        break;
      case 'ABW 140-1:7':
        this.tb1.set('19900');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1407');
        this.tb6.set('1407');
        break;
      case 'ABW 200-1:9':
        this.tb1.set('22144');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set(this.tb2());
        this.tb5.set('1223');
        this.tb6.set('1223');
        break;
      case 'EKW 100-1:6':
      case 'DKW 100-1:6':
      case 'Regel Kr 1:6':
        this.tb1.set('23056');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1902');
        this.tb5.set('157');
        break;
      case 'EKW 140-1:7':
      case 'DKW 140-1:7':
      case 'Regel Kr 1:7':
        this.tb1.set('26448');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1875');
        this.tb5.set('133');
        break;
      case 'EKW 190-1:9':
      case 'DKW 190-1:9':
      case 'Regel Kr 1:9':
        this.tb1.set('32966');
        this.tb2.set((parseInt(this.tb1()) / 2).toString());
        this.tb3.set(this.tb2());
        this.tb4.set('1823');
        this.tb5.set('101');
        break;
      case 'Standard':
        this.tb1.set('30072');
        this.tb2.set('30072');
        this.tb3.set('2200');
        break;
      default:
        break;
    }
  }

  switchDir() {
    this.getTOData(this.selTOType, true);
  }

  startPlaceTOSymbol(event: any) {
    this.action.set('placeTO');
    this.selTOType = this.selTOType * 2 + 1;
    if (this.modalTOEditor.value.richtung == '1') this.selTOType += 1;
    this.map.getViewport().style.cursor = 'crosshair';
    if (this.prevTarget === event.currentTarget) {
      this.action.set('');
      this.prevTarget = undefined;
      event.currentTarget.style.backgroundColor = '#F0F0F0';
      this.map.getViewport().style.cursor = 'grab';
      return;
    }
    if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
    event.currentTarget.style.backgroundColor = '#9E9E9E';
    this.prevTarget = event.currentTarget;
    this.isTurnoutEditorVisible = false;
  }
  changeTB(num: any, event: any) {
    num.set(event.currentTarget.value);
  }

  modifyFeatures: Collection<Feature>;
  dynamicLine: any;

  modifySelected(event: any) {
    if (this.action() !== 'modify') {
      this.action.set('modify');
      this.map.removeInteraction(this.hoverSelect);

      const src = this.modPointsLayer.getSource();
      src.clear();

      setTimeout(() => {
        const feature = this.clickSelect.getFeatures().item(0);
        if (!feature) return;

        const geom = feature.getGeometry();
        if (!geom) return;

        let coords: [number, number][] = [];

        if (geom.getType() === 'Polygon') {
          coords = (geom as Polygon)
            .getCoordinates()[0]
            .slice(0, -1)
            .map(c => [c[0], c[1]] as [number, number]);
        } else {
          coords = (geom as LineString).getCoordinates().map(c => [c[0], c[1]] as [number, number]);
        }

        if (coords.length < 2) return;
        let originalFeatures: Feature<Point>[] = coords.map((c, i) => {
          const f = new Feature({
            geometry: new Point(c),
            type: 'original',
            index: i,
          });
          f.setStyle(originalStyle);
          src.addFeature(f);
          return f;
        });

        let midpointFeatures: Feature<Point>[] = [];

        const createMidpoints = () => {
          midpointFeatures.forEach(f => src.removeFeature(f));
          midpointFeatures = [];

          for (let i = 0; i < originalFeatures.length - 1; i++) {
            const c1 = (originalFeatures[i].getGeometry() as Point).getCoordinates();
            const c2 = (originalFeatures[i + 1].getGeometry() as Point).getCoordinates();

            const mid: [number, number] = [(c1[0] + c2[0]) / 2, (c1[1] + c2[1]) / 2];

            const f = new Feature({
              geometry: new Point(mid),
              type: 'midpoint',
              index: i + 0.5,
            });

            f.setStyle(midpointStyle);
            src.addFeature(f);
            midpointFeatures.push(f);
          }
        };

        createMidpoints();

        const rebuildModify = () => {
          const all = [...originalFeatures, ...midpointFeatures];

          if (this.modify) this.map.removeInteraction(this.modify);

          this.modify = new Modify({
            features: new Collection(all),
          });

          this.map.addInteraction(this.modify);

          this.modify.on('modifyend', handleModifyEnd);
        };

        const updateLine = () => {
          originalFeatures.sort((a, b) => a.get('index') - b.get('index'));

          const lineCoords: [number, number][] = originalFeatures.map(
            f => (f.getGeometry() as Point).getCoordinates() as [number, number]
          );

          if (geom.getType() === 'Polygon') {
            (geom as Polygon).setCoordinates([lineCoords.concat([lineCoords[0]])]);
          } else {
            (geom as LineString).setCoordinates(lineCoords);
          }

          src.changed();
        };

        const handleModifyEnd = (e: any) => {
          let changed = false;

          e.features.forEach((f: Feature<Point>) => {
            if (f.get('type') === 'midpoint') {
              f.set('type', 'original');
              f.setStyle(originalStyle);

              const idx = f.get('index');
              originalFeatures.push(f);

              changed = true;
            }
          });

          if (changed) {
            originalFeatures.sort((a, b) => a.get('index') - b.get('index'));

            originalFeatures.forEach((f, i) => f.set('index', i));

            createMidpoints();

            updateLine();

            rebuildModify();
          } else {
            updateLine();
          }
        };

        rebuildModify();
      }, 50);

      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;
    } else {
      this.action.set('');
      this.modPointsLayer.getSource().clear();

      if (this.modify) this.map.removeInteraction(this.modify);

      this.map.addInteraction(this.hoverSelect);

      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
    }
  }

  getPos(event: any) {
    if (this.action() != 'getPos') {
      this.action.set('getPos');

      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;
    } else {
      this.action.set('');
      this.prevTarget.style.backgroundColor = '#F0F0F0';
    }
  }

  setMeasure(event: any) {
    if (this.action() != 'measure') {
      this.action.set('measure');
      this.measure.SetSecondPoint = false;
      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;

      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.snap);
      this.addInteraction('LineString');
    } else {
      this.action.set('');
      this.prevTarget.style.backgroundColor = '#F0F0F0';
    }
  }

  setMoveAll(event: any) {
    if (this.action() != 'moveAll') {
      this.action.set('moveAll');
      this.measure.SetSecondPoint = false;
      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;

      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.snap);
      this.addInteraction('LineString');
    } else {
      this.action.set('');
      this.prevTarget.style.backgroundColor = '#F0F0F0';
    }
  }

  cutSelected(event: any) {
    if (this.activeElement) {
      this.map.getViewport().style.cursor = 'crosshair';
      this.action.set('cut');
    }
  }
  cutSelectedAtPos(event: any) {
    if (this.activeElement) {
      this.isPositionModalVisible = true;
      this.featLen = geoDesLength(this.activeElement.getGeometry()).toFixed(2);
      this.action.set('cut');
    }
  }
  separateSelected(event: any) {
    if (this.activeElement) {
      this.map.getViewport().style.cursor = 'crosshair';
      this.action.set('separate');
    }
  }
  separateSelectedAtPos(event: any) {
    if (this.activeElement) {
      this.isPositionModalVisible = true;
      this.featLen = geoDesLength(this.activeElement.getGeometry()).toFixed(2);
      this.action.set('separate');
    }
  }

  mergeSelected(event: any) {
    if (this.activeElement) {
      if (this.action() != 'merge') {
        this.action.set('merge');

        if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
        event.currentTarget.style.backgroundColor = '#9E9E9E';
        this.prevTarget = event.currentTarget;
      } else {
        this.action.set('');
        this.prevTarget.style.backgroundColor = '#F0F0F0';
      }
    }
  }

  moveToPos() {
    this.action.set('');
    let info = this.GeoPosMove();
    let coord = info.split(',');

    let pnt = new Point(toLonLat([parseFloat(coord[0]), parseFloat(coord[1])]));
    this.map.getView().fit(pnt, { padding: [170, 50, 30, 150], minResolution: 40 });
    this.isGeoPosModalVisible = false;
  }

  setRotateLine(event: any) {
    if (this.activeElement) {
      this.activeElement = this.rotateLine(this.activeElement);
      this.activeElement.values_.isEdited = true;
      this.enableSave = true;
    }
  }

  sortLine(event: any) {
    if (this.activeElement) {
      if (this.action() != 'sort') {
        this.action.set('sort');

        if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
        event.currentTarget.style.backgroundColor = '#9E9E9E';
        this.prevTarget = event.currentTarget;
      } else {
        this.action.set('');
        this.prevTarget.style.backgroundColor = '#F0F0F0';
      }
    }
  }

  findNearestSegment(coords: Coordinate[], point: Coordinate): any {
    let coord: Coordinate;
    let index = 0;
    let lastIndex = 0;
    let dist = 999999999;
    coords.forEach(element => {
      let line = new LineString([point, element]);
      if (geoDesLength(line) < dist) {
        coord = element;
        dist = geoDesLength(line);
        lastIndex = index;
      }
      index += 1;
    });
    return { coord: coord, index: lastIndex };
  }

  cutLine(val: any) {
    let info = val == -1 ? this.modalCutEditor.value.PositionCut : val;
    let feat = this.activeElement;
    let lastPos = 1;
    let coords = this.activeElement.getGeometry().getCoordinates();
    let coordPoint = feat.getGeometry().getCoordinateAt(parseFloat(info) / geoDesLength(feat.getGeometry()));
    if (parseFloat(info) > geoDesLength(feat.getGeometry()) || parseFloat(info) < 0) return;
    this.len = 0;

    feat.getGeometry().forEachSegment((a, b) => {
      const segment = new LineString([a, b]);
      this.len += Math.round(geoDesLength(segment) * 100) / 100;
      if (this.len > parseFloat(info)) {
        return;
      }
      lastPos += 1;
    });

    let tmp = feat.clone();
    this.map.getViewport().style.cursor = 'grab';
    let splicedCoors = coords.slice(0, lastPos);
    splicedCoors.push(coordPoint);
    feat.getGeometry().setCoordinates(splicedCoors);
    feat.values_.isEdited = true;
    this.enableSave = true;

    //Hard Copy von dem aktiven element, erste Koordinate muss schnittpunkt sein, dann umwandeln in EPSG 4326 (von m in °)
    coords = tmp.getGeometry().getCoordinates();
    coords = coords.slice(lastPos, coords.length);
    coords.splice(0, 0, coordPoint);
    tmp.getGeometry().setCoordinates(coords);
    coords = tmp.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates();

    let c: any = {};
    c.koordinaten = coords;
    c.typid = 1;
    this.apiservice
      .setNewFeature(c)
      .pipe()
      .subscribe((res: any) => {
        let src = this.topojsonLayer.getSource();
        let features = src.getFormat().readFeature(res, {
          featureProjection: 'EPSG:3857',
        });
        this.tempfeaturesList.push({ type: 'new_Line', feature: res });
        src.addFeature(features);
      });

    this.action.set('');
    this.isPositionModalVisible = false;
    return feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates()[lastPos];
  }
  setToBackground(zOrder: number) {
    let x: Feature = this.activeElement;
    x.setProperties({ toSetBack: true });
    this.getLayerStyles();
  }

  objTypChanged(val: number) {
    this.curObjTyp = val;
    this.apiservice
      .getKarteAnlagen(this.curObjTyp)
      .pipe()
      .subscribe((res: any) => {
        if (res) {
          if (this.tblAnl?.columns?.length) this.tblAnl.rows = res.rows;
          else this.tblAnl = res;

          this.selTbl = null;
          this.setFilters();
        }
      });
  }

  TOEditorCreateTO(event: any) {
    if (this.modalTOEditor.value.BezPosition) {
      let c: any = {};
      c.typID = this.selTOType;
      c.Bezeichnung = this.modalTOEditor.value.BezPosition;
      c.tb1 = this.tb1();
      c.tb2 = this.tb2();
      c.tb3 = this.tb3();
      c.tb4 = this.tb4();
      c.tb5 = this.tb5();
      c.tb6 = this.tb6();

      this.apiservice
        .newTOSymbol(c)
        .pipe()
        .subscribe((res: any) => {
          this.getTOData(this.selTOType);
          this.setTOTypes(this.lstWeichen[0]);
        });
    }
  }

  async TOEditorDeleteTO(event: any) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie das ausgewählte Objekt löschen wollen?')
    );

    if (ok) {
      let c: any = {};
      c.typID = this.selTOType;
      c.Bezeichnung = this.selTOObject;
      this.apiservice
        .deleteTOSymbol(c)
        .pipe()
        .subscribe((res: any) => {
          this.getTOData(this.selTOType);
          this.setTOTypes(this.lstWeichen[0]);
        });
    }
  }
  TOEditorEditTO(event: any) {
    let c: any = {};
    c.typID = this.selTOType;
    c.BezeichnungOld = this.selTOObject;
    c.Bezeichnung =
      this.modalTOEditor.value.BezPosition == '' ? this.selTOObject : this.modalTOEditor.value.BezPosition;
    c.tb1 = this.tb1();
    c.tb2 = this.tb2();
    c.tb3 = this.tb3();
    c.tb4 = this.tb4();
    c.tb5 = this.tb5();
    c.tb6 = this.tb6();
    this.apiservice
      .editTOSymbol(c)
      .pipe()
      .subscribe((res: any) => {
        this.getTOData(this.selTOType);
        this.setTOTypes(this.lstWeichen[0]);
      });
  }

  createMapSet() {
    let c: any = {};
    c.ID = this.isnewMapSet ? '-99' : this.curMapSet;
    c.Name = this.SetName();
    this.apiservice
      .saveMapSet(c)
      .pipe()
      .subscribe((res: any) => {
        this.tblKartenset.rows = res.rows;
        setTimeout(() => {
          this.selMapSet.set(c.ID);
        }, 100);
        this.isnewMapSet = false;
        this.isMapSetNameVisible = false;
      });
  }
  changeMapSet() {
    dbS.getGIS(localStorage.getItem('DB') + this.curMapSet).then(x => {
      this.zoomOutAfterRefresh = true;
      localStorage.setItem('karteFileID', this.curMapSet.toString());
      if (x?.features?.length > 0) {
        this.topojsonLayer.getSource().refresh();
      } else {
        this.reloadTopoJson();
      }
    });
  }

  async deleteMapSet() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform(
        'Sind Sie sicher, dass Sie das ausgewählte Kartenset löschen wollen? Damit können Sie nicht mehr auf dessen Elemente zugreifen.'
      )
    );
    if (ok) {
      this.apiservice
        .deleteMapSet(this.curMapSet)
        .pipe()
        .subscribe((res: any) => {
          this.tblKartenset.rows = res.rows;
          setTimeout(() => {
            this.selMapSet.set('1');
            this.curMapSet = 1;
            localStorage.setItem('karteFileID', '1');
            this.reloadTopoJson();
          }, 100);
          this.isnewMapSet = false;
          this.isMapSetNameVisible = false;
          this.toastr.success(this.mrTranslate.transform('Kartenset wurde gelöscht!'));
        });
    }
  }

  onFileOSMChange(event: any) {
    let files: File[] = event.target.files;
    this.spinner.enable();
    let fileReader = new FileReader();
    this.tempfeaturesList = [];
    fileReader.onload = (e: any) => {
      const formatOSM = new OSMXML();
      const features: any = formatOSM.readFeatures(fileReader.result);
      let src = this.topojsonLayer.getSource();
      features.forEach(feat => {
        if (feat.getProperties().railway) {
          // Funktion um nur Tram Features auszulesen
          //let s = feat.values_.railway.toLowerCase();
          //if(s.includes('tram')){
          feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
          feat.setProperties({ layername: 'objekttyp.0' });
          if (feat.getGeometry().getType() == 'Point') {
            feat.setProperties({ PointID: '0' });
          }
          this.tempfeaturesList.push({
            type: 'import_Line',
            feature: feat,
            geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
          });
          src.addFeature(feat);
          //}
        }
      });
      this.enableSave = true;
      this.topojsonLayer.setStyle(this.getLayerStyles());
      this.toastr.success(this.mrTranslate.transform('Daten importiert'));
      this.spinner.disable();
    };
    fileReader.readAsText(files[0]);
  }

  async onFileDXFChange(event: any) {
    let files: File[] = event.target.files;
    this.API_URL = this.apiservice.getURL();
    this.jwt = localStorage.getItem('jwt');

    await this.startHubConnection('DXF');

    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      let base64 = reader.result.toString().split(';base64,')[1];
      let vals = {
        dateiname: files[0].name,
        dateibase64: base64,
      };

      this.http
        .post(this.API_URL + '/files/importdxf/' + this.webSocket._id(), vals, {
          headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.jwt),
          responseType: 'json',
          reportProgress: true,
          observe: 'events',
        })
        .subscribe((val: any) => {
          if (val.body) {
            if (val.body.features) {
              let feature = val.body.features;
              let i: number = 0;
              let src = this.topojsonLayer.getSource();
              const features: any = new OlTopoJSON().readFeatures(feature);
              features.forEach(feat => {
                feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
                this.tempfeaturesList.push({
                  type: 'import_Line',
                  feature: feat,
                  geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
                });
                src.addFeature(feat);
              });

              this.enableSave = true;
              this.topojsonLayer.setStyle(this.getLayerStyles());

              this.toastr.success(this.mrTranslate.transform('Daten importiert'));
              setTimeout(() => {});
            } else {
              this.toastr.error(this.mrTranslate.transform(val.body.error));
            }
            this.fileInputdxf.nativeElement.value = null;
          }
        });
    };
  }

  onFileALKISChange(event: any) {
    let files: File[] = event.target.files;
    this.otypid.set(1);
    this.alkis_file_name = files[0].name;
    this.alkis_file = files[0];
    this.changeALKISTyp(1);

    this.isALKISImportVisible = true;
    this.fileInputALKIS.nativeElement.value = null;
  }

  protected alkisHeaderChange() {
    let v = this.modalAlkis.value;
    this.hasAlkisHeader = v.name != '' && v.schluessel != '';
  }

  protected async changeALKISTyp(id: number) {
    const { naskey, spez, bezeichnung, schluessel } = await firstValueFrom(this.apiservice.geAlkisZoordnung(id));

    this.alkis = naskey;
    this.alkis_spez = spez;

    setTimeout(() => {
      this.modalAlkis.controls.schluessel.setValue(schluessel);
      this.modalAlkis.controls.name.setValue(bezeichnung);

      let v = this.modalAlkis.value;
      this.hasAlkisHeader = v.name != '' && v.schluessel != '';
    });
  }

  async startAlkisImport() {
    this.API_URL = this.apiservice.getURL();
    this.jwt = localStorage.getItem('jwt');
    let v = this.modalAlkis.value;

    this.uploadprocessrun = true;

    await this.startHubConnection('ALKIS');

    let vals = {
      status: 'alkisimport',
      keys: this.alkis,
      schluessel: v.schluessel,
      bezeichnung: v.name,
      file: this.alkis_file_name,
      otypid: this.otypid(),
    };
    this.spinnertitel.set('upload');
    this.runalkis = false;
    (await this.fileUploadService.upload(this.alkis_file)).subscribe(progress => {
      this.uploadprocessprogress.set(progress);
      if (progress == 100) {
        setTimeout(() => {
          this.uploadprocessprogress.set(0);
          if (this.runalkis == false) {
            this.spinnertitel.set('lesen NAS');
            this.http
              .post(this.API_URL + '/files/importalkis/' + this.webSocket._id(), vals, {
                headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.jwt),
                responseType: 'json',
                reportProgress: true,
                observe: 'events',
              })
              .subscribe((val: any) => {
                if (val.body) {
                  if (val.body.ax_objecte) {
                    this.spinnertitel.set('import NAS');
                    this.uploadprocessprogress.set(0);
                    this.uploadprocessrun = true;
                    let ax_objecte = val.body.ax_objecte;
                    let i: number = 0;
                    let src = this.topojsonLayer.getSource();

                    let count: number = 0;
                    const features: any = new OlTopoJSON().readFeatures(ax_objecte);
                    features.forEach(feat => {
                      count++;
                    });
                    features.forEach(feat => {
                      i++;
                      this.uploadprocessprogress.set(parseFloat(((100 * i) / count).toFixed(2)));
                      feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
                      this.tempfeaturesList.push({
                        type: 'import_Line',
                        feature: feat,
                        geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
                      });
                      src.addFeature(feat);
                    });

                    this.enableSave = true;
                    this.topojsonLayer.setStyle(this.getLayerStyles());

                    this.toastr.success(this.mrTranslate.transform('Daten importiert'));
                    setTimeout(() => {
                      this.uploadprocessprogress.set(0);
                      this.uploadprocessrun = false;
                      this.isALKISImportVisible = false;
                    });
                  }
                }
              });
          }
          this.runalkis = true;
        }, 800);
      }
    });
  }

  cancelALKISImport() {
    this.alkis_file_name = '';
    this.alkis_file = null;
    this.isALKISImportVisible = false;
    this.setFilter();
  }

  connected: boolean;
  async startHubConnection(mode: 'ALKIS' | 'DXF') {
    this.webSocket._config.name = `${mode} Upload Progress`;
    await this.webSocket.startCon();
    this.connected = true;
    this.webSocket.registerHandler('taskTextUpdate', text => this.spinnertitel.set(text));
    this.webSocket.registerHandler('taskProgressChanged', progress => this.uploadprocessprogress.set(progress));

    this.webSocket.registerHandler('taskEnded', () =>
      setTimeout(() => {
        this.uploadprocessprogress.set(0);
        this.toastr.success(this.mrTranslate.transform('Daten Hochladen ist abgeschlossen'));
        this.webSocket.stopCon();
      }, 500)
    );
  }

  onFileSHPChange(event: any) {
    let files: File[] = event.target.files;
    let fileReader = new FileReader();
    let stammDatenMap = new Map();

    let jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
    jsZip.loadAsync(files[0]).then(zip => {
      Object.keys(zip.files).forEach(filename => {
        if (filename.includes('.prj')) {
          jsZip.remove(filename);
        }
      });
      zip.generateAsync({ type: 'blob' }).then(z => {
        fileReader.readAsArrayBuffer(z);
      });
    });

    fileReader.onload = (e: any) => {
      this.spinner.enable();
      this.fileInputSHP.set('');
      this.apiservice
        .getStammDatenBez()
        .pipe()
        .subscribe((res: any) => {
          stammDatenMap = new Map(Object.entries(res));
          shp(fileReader.result).then(e => {
            e.features.forEach(fCol => {
              let src = this.topojsonLayer.getSource();
              const features: any = new OlTopoJSON().readFeatures(fCol);
              features.forEach(feat => {
                if (feat.values_.geometry) {
                  feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
                  feat.setProperties({ layername: 'objekttyp.0' });
                  if (feat.getGeometry().getType() == 'Point') {
                    feat.setProperties({ PointID: '0' });
                  }
                  if (feat.getProperties().TRAM && stammDatenMap.has(feat.getProperties().TRAM)) {
                    feat.setProperties({
                      OSTAMMID: stammDatenMap.get(feat.getProperties().TRAM),
                    });
                  }
                  this.tempfeaturesList.push({
                    type: 'import_Line',
                    feature: feat,
                    geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
                  });
                }
              });
              src.addFeatures(features);
              this.enableSave = true;
              this.topojsonLayer.setStyle(this.getLayerStyles());
              this.toastr.success(this.mrTranslate.transform('Daten importiert'));
              this.spinner.disable();
            });
          });
        });
    };
  }

  onFileMRproChange(event: any) {
    let files: File[] = event.target.files;
    let fileReader = new FileReader();

    fileReader.onload = e => {
      const testData = {
        file_upload: fileReader.result,
        id: this.curMapSet,
        name: files[0].name,
      };

      this.apiservice
        .importMRproFile(testData, this.curMapSet)
        .pipe()
        .subscribe((res: any) => {
          if (res?.message && res.message == 'success') {
            dbS.saveIntoGIS(res.data, localStorage.getItem('DB'), this.curMapSet, this.kilometrierung).then(() => {
              dbS.updateGISDate(localStorage.getItem('DB') + this.curMapSet).then(() => {
                this.topojsonLayer.getSource().refresh();
                this.modPointsLayer.getSource().clear();
                this.spinner.disable();
                this.vectorLayerNames = [];
                this.toastr.success(this.mrTranslate.transform('Daten aktualisiert.'));
              });
            });
          } else {
            this.spinner.disable();
          }
        });
    };

    fileReader.readAsText(files[0]);
  }

  async onFileKMZChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const src = this.topojsonLayer.getSource();
    this.spinner.enable();

    try {
      const arrayBuffer = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);

      const kmlFiles = Object.keys(zip.files).filter(f => f.endsWith('.kml'));
      if (!kmlFiles.length) {
        alert('No KML found inside KMZ!');
        return;
      }

      for (const kmlFileName of kmlFiles) {
        const kmlText = await zip.files[kmlFileName].async('text');

        const format = new KML();

        const features = format.readFeatures(kmlText, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        });

        for (const feat of features) {
          const geom = feat.getGeometry();
          if (!geom) continue;

          const geom3857 = geom.clone();
          feat.setGeometry(geom3857);

          feat.setProperties({ layername: 'objekttyp.0' });

          if (geom3857.getType() === 'Point') {
            feat.setProperties({ PointID: '0' });
          }

          const geom4326 = geom3857.clone().transform('EPSG:3857', 'EPSG:4326');

          const coords = (geom4326 as any).getCoordinates();

          this.tempfeaturesList.push({
            type: 'import_Line',
            feature: feat,
            geom: coords,
          });

          src.addFeature(feat);
        }
      }

      this.enableSave = true;
      this.topojsonLayer.setStyle(this.getLayerStyles());

      this.toastr.success(this.mrTranslate.transform('Daten importiert'));
    } catch (err: any) {
      this.toastr.error(this.mrTranslate.transform('Error loading KMZ: ' + err.message.toString()));
    } finally {
      this.spinner.disable();
      input.value = '';
    }
  }

  onFileCSVChange(event: any) {
    const input = event.target as HTMLInputElement;
    let files: File[] = event.target.files;
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.spinner.enable();
      const text = fileReader.result as string;
      const rows = text.split('\n');
      const headers = rows[0].split(',');
      const features: Feature[] = [];

      rows.slice(1).forEach(row => {
        if (row != '') {
          const cols = row.split(';');

          const id = Number(cols[0]);
          const x = Number(cols[1].replace(',', '.'));
          const y = Number(cols[2].replace(',', '.'));

          const feature = new Feature({
            geometry: new Point([x, y]),
            OSTAMMID: id,
          });

          feature.setId(id);

          features.push(feature);
        }
      });

      let src = this.topojsonLayer.getSource();
      features.forEach(feat => {
        const geometry = feat.getGeometry() as Point;
        geometry.transform(this.curEPSG, 'EPSG:3857');
        feat.set('layername', 'objekttyp.0');
        if (geometry.getType() === 'Point') {
          feat.set('PointID', '0');
        }

        const transformedGeometry = geometry.clone().transform('EPSG:3857', 'EPSG:4326') as Point;
        let id = feat.get('OSTAMMID');

        feat.setProperties({ OSTAMMID: id });

        this.tempfeaturesList.push({
          type: 'import_Line',
          feature: feat,
          geom: transformedGeometry.getCoordinates(),
        });

        src.addFeature(feat);
      });

      this.enableSave = true;
      this.topojsonLayer.setStyle(this.getLayerStyles());
      this.toastr.success(this.mrTranslate.transform('Daten importiert'));
      this.spinner.disable();

      input.value = '';
    };

    fileReader.onerror = () => {
      input.value = '';
    };

    fileReader.readAsText(files[0]);
  }

  onFileGeoJSONChange(event: any) {
    const input = event.target as HTMLInputElement;
    let files: File[] = event.target.files;
    let fileReader = new FileReader();

    fileReader.onload = (e: any) => {
      this.spinner.enable();
      const features: any = new GeoJSON().readFeatures(fileReader.result);
      let src = this.topojsonLayer.getSource();
      features.forEach(feat => {
        feat.getGeometry().transform(this.curEPSG, 'EPSG:3857').getCoordinates();
        feat.setProperties({ layername: 'objekttyp.0' });
        if (feat.getGeometry().getType() == 'Point') {
          feat.setProperties({ PointID: '0' });
        }
        this.tempfeaturesList.push({
          type: 'import_Line',
          feature: feat,
          geom: feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
        });
        src.addFeature(feat);
      });
      this.enableSave = true;
      this.topojsonLayer.setStyle(this.getLayerStyles());
      this.toastr.success(this.mrTranslate.transform('Daten importiert'));
      this.spinner.disable();
      input.value = '';
    };
    fileReader.readAsText(files[0]);
  }

  async onFileGPKGChange(event: any) {
    const input = event.target as HTMLInputElement;
    let files: File[] = event.target.files;
    let stammDatenMap = new Map();
    const src = await this.base64service.getUrlStringFromFile(files[0]);
    let c = {
      base64: src.split(',').pop(),
    };
    this.fileInputGPKG.set('');
    this.apiservice
      .getGPKGFeatures(c)
      .pipe()
      .subscribe((dataFromGpkg: any) => {
        this.fileInputGPKG.set('');
        let formatWKB = new ol_format_WKB();

        dataFromGpkg.forEach(fCol => {
          let src = this.topojsonLayer.getSource();
          try {
            let features = formatWKB.readFeature(fCol.EWKB, {
              dataProjection: fCol.proj,
              featureProjection: 'EPSG:3857',
            });
            let feat = features;
            feat.setProperties(fCol.prop);
            feat.setProperties({ layername: 'objekttyp.0' });
            if (feat.getGeometry().getType() == 'Point') {
              feat.setProperties({ PointID: '0' });
            }
            if (feat.getProperties().TRAM && stammDatenMap.has(feat.getProperties().TRAM)) {
              feat.setProperties({
                OSTAMMID: stammDatenMap.get(feat.getProperties().TRAM),
              });
            }
            this.tempfeaturesList.push({
              type: 'import_Line',
              feature: feat,
              geom: (feat.getGeometry().clone().transform('EPSG:3857', 'EPSG:4326') as any).getCoordinates(),
            });
            src.addFeature(feat);
          } catch (error) {
            console.log('Fehler beim erstellen des Features:' + error);
          }
        });
        this.enableSave = true;
        this.topojsonLayer.setStyle(this.getLayerStyles());
        this.toastr.success(this.mrTranslate.transform('Daten importiert'));
        this.spinner.disable();
        input.value = '';
      });
  }

  EPSGChanged(value: string) {
    this.curEPSG = value;
  }

  editFeature() {
    let c: any = {};
    let prop = this.activeElement.getProperties();
    c.ID = prop.ID;
    c.TypID = this.selTbl.OTYPID;
    c.StammID = this.selTbl.OSTAMMID;
    c.koordinaten = this.activeElement.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates();
    c.Name = prop.PointID || '-99';
    if (prop.InternalID) c.InternalID = prop.InternalID;
    c.value = '';
    c.Messwerte = '';
    this.apiservice
      .editFeature(c)
      .pipe()
      .subscribe((res: any) => {
        this.activeElement.values_.OTYPID = this.selTbl.OTYPID;
        this.activeElement.values_.OSTAMMID = this.selTbl.OSTAMMID;
        this.activeElement.getGeometry().transform('EPSG:4326', 'EPSG:3857').getCoordinates();
        if (c.ID == -1) {
          this.tempfeaturesList.push({
            type: 'edit_new_Feature',
            feature: res,
          });
        } else {
          this.activeElement.values_.isEdited = true;
          this.enableSave = true;
        }

        this.toastr.success(this.mrTranslate.transform('Objekt bearbeitet.'));
        this.isObjLinkVisible = false;
      });
  }

  async deleteSelected() {
    let cnt = this.multiSelect.getFeatures().getArray().length;
    if (cnt > 0) {
      if (
        await this.confirmService.danger(
          this.mrTranslate.transform('Sind Sie sicher, dass Sie die ausgewählten Objekte löschen wollen?')
        )
      ) {
        this.multiSelect.getFeatures().forEach(feat => {
          let id = feat.getProperties().ID;
          if (feat.getProperties().InternalID) id = feat.getProperties().InternalID + 'i';
          if (this.deleteFeature(id, feat) == 'OK') this.toastr.success(this.mrTranslate.transform('Objekt gelöscht.'));
        });
      }
    }
  }

  deleteFeature(id: string, feature: any) {
    this.apiservice
      .deleteFeature(id)
      .pipe()
      .subscribe((res: any) => {
        let src = this.topojsonLayer.getSource();
        let srcPoly: OlVectorSource = this.polygonLayer.getSource();
        let features = src.getFormat().readFeature(res, {
          featureProjection: 'EPSG:3857',
        });
        //Wenn das gelöschte ein neu erstelltes Feature aus der temp-Liste ist, aus der temp-Liste entfernen
        this.hasIntIDFound = false;
        for (let index = 0; index < this.tempfeaturesList.length; index++) {
          const el = this.tempfeaturesList[index];
          let feat = el.feature.properties;
          if (
            feat.InternalID &&
            features.getProperties().InternalID &&
            feat.InternalID == features.getProperties().InternalID
          ) {
            this.hasIntIDFound = true;
            this.tempfeaturesList.splice(index, 1);
          }
        }
        if (!this.hasIntIDFound) this.tempfeaturesList.push({ type: 'delete_Line', feature: res });
        src.removeFeature(feature);
        srcPoly.removeFeature(feature);
        return 'OK';
      });
    return '';
  }

  saveFeatures() {
    let v: any = {};
    this.spinner.enable();
    const objSettingsCopy = this.overLayers.base[0].overlays;
    this.topojsonLayer
      .getSource()
      .getFeatures()
      .forEach(feat => {
        if (feat.getProperties().isEdited) {
          this.tempfeaturesList.push({
            type: 'edit_Feature',
            feature: feat.getProperties(),
            geom: feat.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
            geomType: feat.getGeometry().getType(),
          });
          feat.getGeometry().transform('EPSG:4326', 'EPSG:3857').getCoordinates();
        }
      });
    this.polygonLayer
      .getSource()
      .getFeatures()
      .forEach(feat => {
        if (feat.getProperties().isEdited) {
          this.tempfeaturesList.push({
            type: 'edit_Feature',
            feature: feat.getProperties(),
            geom: feat.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates(),
            geomType: feat.getGeometry().getType(),
          });
          feat.getGeometry().transform('EPSG:4326', 'EPSG:3857').getCoordinates();
        }
      });
    v.fileID = this.curMapSet;
    v.features = this.tempfeaturesList;

    this.apiservice
      .saveFeatures(v)
      .pipe()
      .subscribe((res: any) => {
        this.spinner.disable();
        if (res) {
          this.tempfeaturesList = [];
        }
        this.reloadTopoJson(0,objSettingsCopy);
      });
    this.reset();
  }

  rotateSymbol(event) {
    if (this.activeElement?.getProperties().PointID) {
      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;

      this.action.set('rotate');
    }
  }
  moveSymbol(event) {
    if (
      this.activeElement &&
      (this.activeElement.getProperties().PointID || this.activeElement.getGeometry().getType() == 'Point')
    ) {
      if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
      event.currentTarget.style.backgroundColor = '#9E9E9E';
      this.prevTarget = event.currentTarget;

      this.action.set('move');
    }
  }

  GetBearing(sP, eP) {
    let angle = Math.atan2(eP[1] - sP[1], eP[0] - sP[0]);
    return angle;
  }

  startEdit() {
    this.map.interactions.array_ = this.editInteractions;
  }

  undoDraw() {
    this.draw.removeLastPoint();
  }

  reloadTopoJson(typ: number = 0, existingObjectSettings: any = undefined) {
    if (!this.authService.getRight('view', 'AllowVMAP')) return;
    if (typ == 1) this.isloadRecycle = true;
    this.spinner.enable();
    this.reset();
    if (!this.curMapSet) this.curMapSet = 1;
    localStorage.setItem('karteFileID', this.curMapSet.toString());
    this.apiservice
      .refreshTopoJson(this.curMapSet, this.pruefungsTyp.KPRUVID(), typ)
      .pipe()
      .subscribe((res: any) => {
        if (res?.message && res.message == 'success') {
          if (res?.kilometrierung && res.kilometrierung == true) {
            this.kilometrierung = true;

            const newItem = {
              name: 'Kilometrierung',
              key: 'objekttyp.1945',
              icon: 1945,
              enable: true,
              color: 'black',
            };

            const overlays = this.overLayers.base[0].overlays;
            if (!overlays.some(item => item.key === newItem.key)) {
              overlays.push(newItem);
            }
          }

          dbS.saveIntoGIS(res.data, localStorage.getItem('DB'), this.curMapSet, this.kilometrierung).then(() => {
            dbS.updateGISDate(localStorage.getItem('DB') + this.curMapSet).then(() => {
              this.topojsonLayer.getSource().refresh();
              this.modPointsLayer.getSource().clear();
              this.spinner.disable();
              this.vectorLayerNames = [];
              this.toastr.success(this.mrTranslate.transform('Daten aktualisiert.'));
              this.isloadRecycle = false;
            });
          });
        } else {
          this.spinner.disable();
          this.isloadRecycle = false;
        }
      });
    this.overLayers = duplicate(this.overLayersOriginal);
    this.getStrValues(undefined, existingObjectSettings !== undefined);
    if (existingObjectSettings) {
      this.overLayers.base[0].overlays = existingObjectSettings;
    }
  }
  reset() {
    this.action.set('');
    this.enableSave = false;
    this.tempfeaturesList = [];

    if (this.prevTarget) this.prevTarget.style.backgroundColor = '#F0F0F0';
  }

  pathJoin(parts, separator = '/') {
    let replace = new RegExp(separator + '{1,}', 'g');
    return parts.join(separator).replace(replace, separator);
  }

  rotateLine(feat: Feature<LineString>): Feature<LineString> {
    feat.getGeometry().setCoordinates(feat.getGeometry().getCoordinates().reverse());
    return feat;
  }

  hoverStyleFunction() {
    return (feature, resolution) => {
      let valmap = (x, in_min, in_max, out_min, out_max) => {
        return ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
      };

      let feat = feature;
      let geom = feat.getGeometry();
      let prop = feat.getProperties();
      if (geom.getType() == 'LineString' || geom.getType() == 'MultiLineString') {
        if (prop.layername == 'objekttyp.0') {
          this.elementStyles.line.getStroke().setColor(this.hoverEmptyColor);
          this.elementStyles.line.getStroke().setLineDash([6, 6]);
          this.elementStyles.line.setZIndex(0);
        } else {
          this.elementStyles.line.getStroke().setColor(this.hoverColor);
          this.elementStyles.line.getStroke().setLineDash([6, 6]);
          this.elementStyles.line.setZIndex(99);

          this.objSetText(prop, this.elementStyles.line);
        }

        this.modPointsLayer.setStyle(this.modPointStyleFunction());

        let styles = [this.elementStyles.line];
        let map = this.map;
        if (this.showMangelBem && prop.Bemerkung) {
          this.infoHTML.set(prop.Bemerkung);
          let coordinates = prop.geometry.getCoordinates();
          let end = coordinates[Math.floor(coordinates.length / 2)];
          let endp = this.map.getPixelFromCoordinate(end);
          this.infoStyle.set('visibility:visible;left:' + endp[0] + 'px' + ';top:' + endp[1] + 'px');
        } else {
          this.infoStyle.set('visibility:hidden;');
        }

        // Arrow heads
        if ((objtype.isLine(prop.OTYPID) || geom.getType() == 'LineString') && !prop.PointID) {
          let tmpFeat = geom as LineString;
          let coordinates = tmpFeat.getCoordinates();
          let coordlen = coordinates.length;
          let end = coordinates[coordlen - 1];
          let beforeEnd = coordinates[coordlen - 2];
          let dx = end[0] - beforeEnd[0];
          let dy = end[1] - beforeEnd[1];
          let angle = Math.atan2(dy, dx) + Math.PI / 2;
          let endp = map.getPixelFromCoordinate(end);

          // 17 - 10
          // 12 - 5#
          const val = valmap(map.getView().getZoom(), 10, 20, 4, 10);

          let coords = [
            [
              [endp[0] + val, endp[1]],
              [endp[0], endp[1] + val * 1.8],
              [endp[0] - val, endp[1]],
              [endp[0] + val, endp[1]],
            ],
          ];
          coords[0] = coords[0].map(val => {
            return map.getCoordinateFromPixel(val);
          });

          let polygon = new OlPolygon(coords);
          polygon.rotate(angle, end);
          styles.push(
            new OlStyle({
              zIndex: 99,
              geometry: polygon,
              fill: new OlFill({
                color: prop.OTYPID ? this.hoverColor : this.hoverEmptyColor,
              }),
            })
          );
        }

        return styles;
      } else if (geom.getType() == 'Point' && prop.OSTAMMID > 0 && !prop.PointID) {
        let pfad = 'assets/icons/GM_Typ_0.svg';
        if (!prop.PointID || prop.PointID == '0' || (prop.PointID == '' && prop.SYSICON > 0)) {
          const key = `objekttyp${prop.SYSICON}`;
          pfad = `assets/icons/${key}.svg`;
        }

        this.elementStyles.point.setImage(
          new Icon({
            src: pfad,
            scale: 0.2 / resolution,
            rotation: prop.angle,
            color: this.hoverColor,
          })
        );
        this.objSetText(prop, this.elementStyles.point);
        return this.elementStyles.point;
      } else if (geom.getType() == 'Point' && prop.PointID) {
        let smallIcon =
          prop.PointID == '0' ||
          prop.PointID == '5' ||
          prop.PointID == '23' ||
          (prop.PointID >= '30' && prop.PointID <= '41');

        let pfad = `assets/icons/GM_Typ_${prop.PointID}.svg`;
        if (prop.PointID == '0' && prop.SYSICON > 0) {
          const key = `objekttyp${prop.SYSICON}`;
          pfad = `assets/icons/${key}.svg`;
        }

        let imagestl = new Icon({
          src: pfad,
          scale: smallIcon ? 0.2 / resolution : 0.3 / resolution,
          rotation: prop.angle,
          anchor: smallIcon ? [0.5, 0.5] : [0.5, 1],
          color: this.hoverColor,
        });
        this.elementStyles.point.setImage(imagestl);
        this.objSetText(prop, this.elementStyles.point);
        return this.elementStyles.point;
      } else if (geom.getType() == 'Polygon') {
        this.elementStyles.polygon.getStroke().setColor(this.hoverColor);
        this.elementStyles.polygon.getStroke().setLineDash([6, 6]);
        this.elementStyles.polygon.getFill().setColor('rgba(0, 0, 255, 0.4)');
        this.elementStyles.polygon.setZIndex(prop.toSetBack ? -99 : 99);
        this.objSetText(prop, this.elementStyles.polygon);
        return this.elementStyles.polygon;
      }
    };
  }
  modPointStyleFunction() {
    return (feature, resolution) => {
      this.elementStyles.point.setImage(
        new CircleStyle({
          radius: 4,
          stroke: new OlStroke({
            color: 'rgba(0,0,0,0.6)',
            width: 2,
          }),
          fill: new OlFill({ color: 'blue' }),
        })
      );
      return this.elementStyles.point;
    };
  }

  showPos(feature: any) {
    let isLineString: boolean =
      this.activeElement.getGeometry().getType() == 'LineString' && !this.activeElement.getProperties().PointID;
    if (
      this.mousepos &&
      this.activeElement &&
      feature == this.clickSelect.getFeatures().item(0) &&
      this.action() != 'modify'
    ) {
      this.len = 0;
      this.lenSphere = 0;
      let closePnt = feature.getGeometry().getClosestPoint(this.mousepos);

      if (isLineString) {
        this.len = feature.getGeometry().forEachSegment((a, b) => {
          const segment = new LineString([a, b]);
          const closeSeg = segment.getClosestPoint(this.mousepos);
          if (closeSeg[0] == closePnt[0] && closeSeg[1] == closePnt[1]) {
            const segToMouse = new LineString([a, closeSeg]);
            this.len += geoDesLength(segToMouse);
            return this.len;
          }
          this.len += Math.round(geoDesLength(segment) * 100) / 100;
        });
        if (!this.len || this.len > geoDesLength(feature.getGeometry())) return;
      }
      let visibility = 'visible';

      let innerHTML = '';
      let addlStyle: string = '';
      if (isLineString) {
        if (feature.getProperties().layername.includes('stamm.bauwerke')) {
          innerHTML +=
            '' +
            feature.getProperties().layername.slice(15) +
            "<br> '" +
            feature.getProperties().Bezeichnung +
            "'<br><br>";
          addlStyle = 'width:200px';
        }
        if (feature.getProperties().layername.includes('stamm.naturschutz')) {
          innerHTML +=
            'Schutzgrad ' +
            feature.getProperties().layername.slice(18) +
            "<br> '" +
            feature.getProperties().Bezeichnung +
            "'<br><br>";
          addlStyle = 'width:200px';
        } else {
          if (feature.values_.startmeter) {
            let l = this.len;
            let dir = feature.values_.endmeter > feature.values_.startmeter ? 0 : 1;
            if (dir === 0) {
              this.len = feature.values_.startmeter + l;
            } else {
              this.len = feature.values_.startmeter - l;
            }
          }

          innerHTML +=
            this.convertToUnit(this.len) +
            ' <br><font size = 1> ' +
            this.convertToUnit(geoDesLength(feature.getGeometry())) +
            '</font>';
        }

        if (this.altPressed)
          innerHTML +=
            '<br><font size = 1> ' +
            feature.getProperties().layername +
            '<br>ID: ' +
            feature.getProperties().ID +
            '<br> Stamm:' +
            feature.getProperties().OSTAMMID +
            '<br></font>';
      } else if (this.altPressed)
        innerHTML =
          '<font size = 1>' +
          this.activeElement.getProperties().layername +
          '<br>ID: ' +
          this.activeElement.getProperties().ID +
          '<br>Stamm:' +
          this.activeElement.getProperties().OSTAMMID +
          '<br>PointID:' +
          this.activeElement.getProperties().PointID +
          '</font>';
      else visibility = 'hidden';
      let pendp = this.map.getPixelFromCoordinate(closePnt);
      this.posHTML.set(innerHTML);
      this.posStyle.set(
        'visibility:' + visibility + '; left:' + (pendp[0] - 6) + 'px' + '; top:' + (pendp[1] + 7) + 'px;' + addlStyle
      );
    } else {
      this.posStyle.set('visibility:hidden; innerText:null');
    }
  }
  ngOnDestroy(): void {
    if (this.map) {
      this.basicStore.setComponentStore(
        'karte',
        {
          view: this.map.getView(),
          baseLayer: this.baseLayer,
          overLayer: this.overLayIds,
          activeElement: this.activeElement,
          ostammid: this.ostammid,
          showdetailview: this.showdetailview,
          // * wird gespeichert, aber restoreMapState wird nirgends aufgerufen
          hidedetailview: this.hidedetailview,
          sidenavenlarged: this.sidenavenlarged,
          progressbarenlarged: this.progressbarenlarged,
          split50: this.split50,
        },
        false
      );

      this.map.setTarget(undefined);
    }

    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  ngOnInit(): void {
    if (!this.authService.getRight('view', 'AllowVMAP')) dbS.clearGis();
    this.alertService.startPolling();
    dbS.getGISDate(localStorage.getItem('DB') + this.curMapSet).then(x => {
      if (x) {
        this.apiservice
          .karteCompareDate(x, this.curMapSet)
          .pipe()
          .subscribe((res: any) => {
            if (res) {
              dbS.updateGISDate(localStorage.getItem('DB') + this.curMapSet).then(() => {
                if (!this.doreloadTopoJson) this.reloadTopoJson();
              });

              dbS.getGISKilometrierung(localStorage.getItem('DB') + this.curMapSet).then(x => {
                if (x) {
                  this.kilometrierung = x;

                  const newItem = {
                    name: 'Kilometrierung',
                    key: 'objekttyp.1945',
                    icon: 1945,
                    enable: true,
                    color: 'black',
                  };

                  const overlays = this.overLayers.base[0].overlays;
                  if (!overlays.some(item => item.key === newItem.key)) {
                    overlays.push(newItem);
                  }
                }
              });
            }
          });
      } else {
        this.reloadTopoJson();
      }
    });

    this.loadLinien();

    this.authService
      .get$token()
      .pipe()
      .subscribe(token => {
        if (token?.rights) {
          this.canEdit = !this.isRep && getTokenRight(token.rights.view, 'AllowVMAPEDIT');
        }
      });

    this.apiservice
      .getMapSettings()
      .pipe()
      .subscribe((res: any) => {
        if (res) {
          this.tblKartenset = res.mapSet;

          //Fallback:Prüfe ob KartenSet-ID überhaupt existiert (z.B. bei Wechsel der Datenbanken). Wenn nicht auf 1 zurücksetzen
          if (!res.mapSet.rows.some(x => x.ID == this.curMapSet)) {
            this.curMapSet = 1;
          }
        }
      });

    this.apiservice
      .getObjekttypen()
      .pipe()
      .subscribe((val: any) => {
        this.tblObjektTypen = val;
      });

    this.positionStyle = new OlStyle({
      image: new CircleStyle({
        radius: 6,

        fill: new Fill({
          color: '#3399CC',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 2,
        }),
      }),
    });

    this.posLayer = new OlVectorLayer({
      map: this.map,
      source: new OlVectorSource({
        features: [this.accuracyFeature, this.positionFeature, this.positionCamFeature],
      }),
    });

    this.posBarLayer = new OlVectorLayer({
      map: this.map,
      source: new OlVectorSource({
        features: [this.accuracyFeature, this.positionBarFeature],
      }),
    });
  }
  selectFeature(feature, map?, cb?) {
    this.modPointsLayer.getSource().clear();
    this.clickSelect.getFeatures().clear();
    this.clickSelect.dispatchEvent({
      type: 'select',
      selected: [feature],
    });
  }

  initMap(apikeys: any) {
    const storeddata = this.basicStore.getComponentStore('karte');
    const view = storeddata?.view;

    //PROJ4 erlaubt mehrere EPSG-Definitionen, OL nur die standards 3857 (Welt in m) und 4326 (Welt in °). Daher in PROJ4 alles laden und mit OL verknüpfen.
    const proj4x = (proj4 as any).default;
    proj4x.defs(
      'EPSG:2146',
      '+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:2056',
      '+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:21781',
      '+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs +type=crs'
    );
    proj4x.defs('EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs');
    proj4x.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs');
    proj4x.defs('EPSG:25833', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs');
    proj4x.defs(
      'EPSG:31466',
      '+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +ellps=bessel +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:31467',
      '+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +ellps=bessel +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:31468',
      '+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +ellps=bessel +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:31469',
      '+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +ellps=bessel +units=m +no_defs +type=crs'
    );
    proj4x.defs(
      'EPSG:31370',
      '+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,-0.3366,0.457,-1.8422,-1.2747 +units=m +no_defs +type=crs'
    );
    proj4x.defs('EPSG:32633', '+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs +type=crs');
    register(proj4x);

    addEventListener('keyup', e => {
      this.altPressed = false;
      this.shiftPressed = false;
    });

    addEventListener('keydown', e => {
      if (e.altKey) this.altPressed = true;
      if (e.shiftKey) this.shiftPressed = true;
      if (e.ctrlKey && e.key == 'z' && this.action() == 'draw') this.draw.removeLastPoint();
      if (e.key == 'Escape') {
        if (this.action() == 'draw') {
          this.draw.abortDrawing();
        }
        if (this.action() == 'modify') {
          this.modPointsLayer.getSource().clear();
          this.modPointsLayer.getSource().refresh();
        }
        if (this.action() == 'drawarc') {
          this.markers = [];
          let src = this.topojsonLayer.getSource();
          src.removeFeature(this.drawarcFeature);
          this.drawarcFeature = undefined;
        }
        this.action.set('');
        this.showdetailview = false;
        this.ostammid = undefined;
        this.activeElement = undefined;
        this.modPointsLayer.getSource().clear();
        this.clickSelect.getFeatures().clear();
        this.hoverSelect.getFeatures().clear();
      }
      if (e.key == 'Enter') {
        if (this.action() == 'draw') {
          this.draw.finishDrawing();
        }
      }
      if (e.key == 'Delete' && this.activeElement) {
        this.deleteSelected();
      }
    });
    addEventListener('keyup', e => {
      if (e.altKey) this.altPressed = false;
    });

    if (storeddata == undefined) {
      let karte = this.persistanceService.get('karte');

      if (karte != null) {
        this.baseLayer.push(karte.p, karte.m);
      }
    }
    let karteFarbe = this.persistanceService.get('karteFarbe');
    if (karteFarbe != null) {
      this.baseColor = karteFarbe.bC;
      this.hoverColor = karteFarbe.hC;
      this.hoverEmptyColor = karteFarbe.hEC;
    }

    this.showdetailview = storeddata?.showdetailview ?? false;
    this.hidedetailview = storeddata?.hidedetailview ?? false;
    this.ostammid = this.showdetailview && storeddata?.ostammid ? storeddata.ostammid : undefined;

    if (apikeys.mapbox) {
      let mapboxkeys = Object.keys(this.tileLayers.mapbox);
      for (const mpk of mapboxkeys) {
        let newmapboxURL = this.tileLayers.mapbox[mpk].getSource().getUrls()[0].replace('$$apikey$$', apikeys.mapbox);
        this.tileLayers.mapbox[mpk].getSource().setUrl(newmapboxURL);
      }
    }

    this.layers = [];
    Object.keys(this.tileLayers).forEach(catname => {
      Object.keys(this.tileLayers[catname]).forEach(layername => {
        try {
          this.layers.push(this.tileLayers[catname][layername]);
          this.tileLayers[catname][layername].setVisible(false);
        } catch {}
      });
    });

    this.layers.push(
      this.polygonLayer,
      this.topojsonLayer,
      this.modPointsLayer,
      this.gleisMessLayer,
      this.railProfilesLayer
    );

    this.clickSelect = new OlSelect({
      condition: singleClick,
      multi: false,
      style: this.hoverStyleFunction(),
    });
    this.hoverSelect = new OlSelect({
      condition: pointerMove,
      multi: false,
      style: this.hoverStyleFunction(),
    });
    this.multiSelect = new OlSelect({
      condition: singleClick,
      style: this.hoverStyleFunction(),
    });
    this.modify = new Modify({
      features: this.clickSelect.getFeatures(),
      style: this.hoverStyleFunction(),
      insertVertexCondition: () => {
        return this.shiftPressed;
      },
      deleteCondition: () => {
        return this.altPressed;
      },
    });

    this.map = new OlMap({
      target: 'map',
      pixelRatio: 2,
      //loadTilesWhileInteracting: true,
      maxTilesLoading: 20,
      interactions: defaultInt({
        altShiftDragRotate: true,
        onFocusOnly: false,
        //constrainResolution: false,
        doubleClickZoom: true,
        keyboard: true,
        mouseWheelZoom: true,
        shiftDragZoom: true,
        dragPan: true,
        pinchRotate: false,
        pinchZoom: true,
      }),
      layers: this.layers,
      view: new OlView({
        center: view ? view.getCenter() : fromLonLat([6.747443, 49.981018]),
        maxZoom: 23,
        zoom: view ? view.getZoom() : 6,
      }),
      controls: defaults({ attribution: false, rotate: false }).extend([
        new OlAttribution({
          collapsible: true,
          collapsed: true,
        }),
        new OlFullScreen({
          source: 'content-area',
        }),
      ]),
    });

    this.map.on('postcompose', e => {
      this.mapready$.next(true);
    });

    // Create popup AFTER map exists
    this.popup = new OlOverlay({
      element: this.popupElement.nativeElement,
      positioning: 'top-center',
      offset: [0, 15],
      stopEvent: false,
    });

    this.map.addOverlay(this.popup);

    this.map.getView().on('change:resolution', event => {
      let l = this.baseLayer;
      let s = event.target.nextResolution_;
      if (l[1] == 'he_ortho') {
        if (s > 4) {
          this.tileSwitch('sonstige', 'he_ortho1');
        }
      }

      if (l[1] == 'he_ortho1') {
        if (s < 4) {
          this.tileSwitch('sonstige', 'he_ortho');
        }
      }
    });

    this.map.on('pointermove', e => {
      this.mousepos = e.coordinate;
      if ((!this.activeElement && this.action() != 'drawarc') || this.action() == 'draw') {
        this.posStyle.set('visibility:hidden;innerText:null');
        return;
      }
      if (this.action() == 'drawarc') {
        this.activeElement = this.drawarcFeature;
        if (this.markers.length == 3) {
          this.markers[2] = this.mousepos;
          let L = new LineString(this.GetPointsOfArc(this.markers));
          this.dlgRadius = (getLength(L) / 2).toFixed(2) + ' m';
          this.drawarcFeature.setGeometry(L);
          let closePnt = this.activeElement.getGeometry().getClosestPoint(this.mousepos);
          let pendp = this.map.getPixelFromCoordinate(closePnt);
          this.posHTML.set(this.dlgRadius);
          this.posStyle.set('visibility:visible; left:' + (pendp[0] - 6) + 'px' + '; top:' + (pendp[1] + 7) + 'px');

          this.topojsonLayer.setStyle(this.getLayerStyles());
        }
        if (this.markers.length == 1) {
          let L = new LineString([this.markers[0], this.mousepos]);
          this.drawarcFeature.setGeometry(L);
          this.topojsonLayer.setStyle(this.getLayerStyles());
        }
        return;
      }
      let isTO = false;
      let coord = this.activeElement.getGeometry().getCoordinates();
      if (coord.length > 2) {
        coord = coord[0];
        isTO = true;
      }

      this.showPos(this.activeElement);

      if (this.action() == 'rotate') {
        let centercoords = this.activeElement.getGeometry().getCoordinates();
        let pointID = this.activeElement.getProperties().PointID;
        let a = this.GetBearing(coord, this.mousepos);

        this.activeElement.values_.angle = -a;

        if (this.altPressed) {
          let pendp = this.map.getPixelFromCoordinate(this.mousepos);
          this.posHTML.set(
            'angle :' +
              (-a / Math.PI) * 180 +
              ' - activengle: ' +
              ((this.activeElement.values_.angle / Math.PI) * 180 + 90)
          );
          this.posStyle.set('visibility:visible; left:' + (pendp[0] - 6) + 'px' + '; top:' + (pendp[1] + 7) + 'px;');
        } else {
          this.posStyle.set('visibility:hidden; innerText:null');
        }

        if (this.activeElement.values_.geometryReadings) {
          if (this.prevangle == 0) {
            let compPoint =
              pointID == 7 || pointID == 8 ?
                centercoords[centercoords.length - 1]
              : centercoords[centercoords.length - 3];
            let b = this.GetBearing(coord, compPoint);
            this.activeElement.getGeometry().rotate(-b, centercoords[0]);
            this.topojsonLayer.setStyle(this.getLayerStyles());
          }
          this.activeElement.getGeometry().rotate(a - this.prevangle, centercoords[0]);
        } else this.activeElement.values_.angle += 1.5;
        this.prevangle = a;
        this.topojsonLayer.setStyle(this.getLayerStyles());
      }
      if (this.action() == 'move') {
        if (isTO) {
          let x = coord[0] - this.mousepos[0]; //-10;
          let y = coord[1] - this.mousepos[1]; //-10;
          let coords = [];
          this.activeElement
            .getGeometry()
            .getCoordinates()
            .forEach(coo => {
              coo[0] = coo[0] - x;
              coo[1] = coo[1] - y;
              coords.push(coo);
            });
          this.activeElement.getGeometry().setCoordinates(coords);
        } else {
          this.activeElement.getGeometry().setCoordinates([this.mousepos[0] - 4, this.mousepos[1] - 4]);
        }
        this.topojsonLayer.setStyle(this.getLayerStyles());
      }
    });

    this.map.on('pointerdown', e => {
      let isDragging = true;
    });

    this.map.on('click', e => {
      let coord = toLonLat(e.coordinate);
      this.popup.setPosition(undefined);

      const features: Feature[] = [];
      this.map.forEachFeatureAtPixel(
        e.pixel,
        feature => {
          let prop = feature.getProperties();
          if (prop.Bezeichnung && prop.layername !== 'objekttyp.2' && prop.layername !== 'objekttyp.0') {
            features.push(feature as Feature);
          }
        },
        {
          hitTolerance: 5,
        }
      );

      this.doshowFeatureMenu = false;

      if (features.length <= 1) {
        this.closeFeatureMenu();
      }

      if (features.length > 1) {
        this.doshowFeatureMenu = true;
        this.showFeatureMenu(e.pixel, features);
        return;
      }

      if (this.action() == 'rotate') {
        this.action.set('');
        this.prevangle = 0;
        let c: any = {};
        c.id = this.activeElement.values_.ID;
        c.angle = this.activeElement.values_.angle;
        this.activeElement.values_.isEdited = true;
        this.enableSave = true;
      }

      if (this.action() == 'drawarc') {
        if (this.markers.length == 3) {
          if (this.arcShowDlgOnly) {
            let src = this.topojsonLayer.getSource();
            src.removeFeature(this.drawarcFeature);
            this.drawarcFeature = undefined;
            this.isGeoPosModalVisible = true;
          } else {
            let c: any = {};
            c.koordinaten = this.activeElement
              .getGeometry()
              .clone()
              .transform('EPSG:3857', 'EPSG:4326')
              .getCoordinates();
            c.typid = 1;

            this.apiservice
              .setNewFeature(c)
              .pipe()
              .subscribe((res: any) => {
                let src = this.topojsonLayer.getSource();
                let features = src.getFormat().readFeature(res, {
                  featureProjection: 'EPSG:3857',
                });
                this.activeElement.values_.InternalID = features.getProperties().InternalID;
                this.tempfeaturesList.push({ type: 'new_Line', feature: res });
                this.enableSave = true;
              });
          }
          this.markers = [];
          this.drawarcFeature = undefined;
          this.prevTarget.style.backgroundColor = '#F0F0F0';
          this.action.set('');
        }
        if (this.markers.length == 1) {
          this.markers.push(this.mousepos, this.mousepos);
        }
        if (this.markers.length == 0) {
          this.markers.push(this.mousepos);
          this.drawarcFeature = new Feature(new LineString([this.markers[0], this.markers[0]]));
          this.drawarcFeature.setProperties({ layername: 'objekttyp.0' });
          let src = this.topojsonLayer.getSource();
          src.addFeature(this.drawarcFeature);
        }

        return;
      }

      if (this.action() == 'modify' && !this.altPressed) {
        this.map.removeInteraction(this.modify);
        this.map.addInteraction(this.hoverSelect);
        this.activeElement.values_.isEdited = true;
        this.enableSave = true;
        this.action.set('');
      }

      if (this.action() == 'move') {
        this.action.set('');
        this.activeElement.values_.isEdited = true;
        this.enableSave = true;
      }

      if (this.action() == 'cut' || this.action() == 'separate') {
        if (this.posStyle().includes('visibility:visible')) {
          let closePnt = this.activeElement.getGeometry().getClosestPoint(this.mousepos);
          let coords = this.activeElement.getGeometry().getCoordinates();
          let lastPos = 1;
          let totalLen = 0;
          for (let i = 0; i < coords.length - 1; i++) {
            let line = new LineString([coords[i], coords[i + 1]]);
            totalLen += geoDesLength(line);
            if (totalLen < this.len) {
              lastPos = i + 2;
            } else break;
          }
          if (lastPos > 0) {
            let tmp = this.activeElement.clone();
            this.map.getViewport().style.cursor = 'grab';
            let splicedCoors = coords.splice(0, lastPos);
            splicedCoors.push(closePnt);
            this.activeElement.getGeometry().setCoordinates(splicedCoors);
            this.activeElement.values_.isEdited = true;
            this.enableSave = true;

            if (this.action() == 'separate') {
              //Hard Copy von dem aktiven element, erste Koordinate muss schnittpunkt sein, dann umwandeln in EPSG 4326 (von m in °)
              coords = tmp.getGeometry().getCoordinates();
              coords = coords.slice(lastPos, coords.length);
              coords.splice(0, 0, closePnt);
              tmp.getGeometry().setCoordinates(coords);
              coords = tmp.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates();

              let c: any = {};
              c.koordinaten = coords;
              c.typid = 1;
              this.apiservice
                .setNewFeature(c)
                .pipe()
                .subscribe((res: any) => {
                  let src = this.topojsonLayer.getSource();
                  let features = src.getFormat().readFeature(res, {
                    featureProjection: 'EPSG:3857',
                  });
                  if (geoDesLength(features.getGeometry()) >= 1) {
                    //Gleis muss min 1 meter lang sein
                    this.tempfeaturesList.push({
                      type: 'new_Line',
                      feature: res,
                    });
                    src.addFeature(features);
                  }
                });
            }
          }
        }
        this.action.set('');
      }

      if (this.action() == 'merge') {
        this.action.set('');
        if (this.hoverSelect.getFeatures().item(0) != this.activeElement) {
          if (this.hoverSelect.getFeatures().item(0).getGeometry().getType() == 'LineString') {
            let lastCoord = this.activeElement.getGeometry().getCoordinates()[
              this.activeElement.getGeometry().getCoordinates().length - 1
            ];
            let curfeat: Feature<LineString> = this.hoverSelect.getFeatures().item(0);
            //Nächstes gewähltes Element drehen, falls nicht mit der Richtung des ursprünglichen Linestrings übereinstimmend.
            let lineEnd1 = new LineString([lastCoord, curfeat.getGeometry().getCoordinates()[0]]);
            let lineEnd2 = new LineString([
              lastCoord,
              curfeat.getGeometry().getCoordinates()[curfeat.getGeometry().getCoordinates().length - 1],
            ]);
            if (geoDesLength(lineEnd2) < geoDesLength(lineEnd1)) {
              curfeat = this.rotateLine(curfeat);
            }
            this.activeElement
              .getGeometry()
              .setCoordinates(
                this.activeElement.getGeometry().getCoordinates().concat(curfeat.getGeometry().getCoordinates())
              );
            this.activeElement.values_.isEdited = true;
            this.enableSave = true;
            this.deleteFeature(curfeat.getProperties().ID, curfeat);
          }
        }
      }

      if (this.action() == 'sort') {
        this.action.set('');
        let coords: Coordinate[] = this.activeElement.getGeometry().clone().getCoordinates();
        let closePnt = this.findNearestSegment(coords, this.mousepos);
        let out: Coordinate[] = [];
        out.push(closePnt.coord);
        coords.splice(closePnt.index, 1);
        let x = 0;
        for (const element of coords) {
          let closest = this.findNearestSegment(coords, out.at(-1));
          out.push(closest.coord);
          coords.splice(closest.index, 1);
          x += 1;
        }
        out = out.concat(coords);
        this.activeElement.getGeometry().setCoordinates(out);
        this.activeElement.values_.isEdited = true;
        this.enableSave = true;
      }

      if (this.action() == 'place') {
        this.action.set('');
        this.prevTarget.style.backgroundColor = '#F0F0F0';
        this.prevTarget = undefined;
        this.map.getViewport().style.cursor = 'grab';
        let c: any = {};
        c.koordinaten = coord;
        c.name = this.curSymbol;
        this.apiservice
          .setNewSymbol(c)
          .pipe()
          .subscribe((res: any) => {
            let src = this.topojsonLayer.getSource();
            let features = src.getFormat().readFeature(res, {
              featureProjection: 'EPSG:3857',
            });
            this.tempfeaturesList.push({ type: 'new_Symbol', feature: res });
            src.addFeature(features);
          });
      }
      if (this.action() == 'placeTO') {
        let rotateAtEnd = false;
        let fullcoord;
        this.action.set('');
        this.prevTarget.style.backgroundColor = '#F0F0F0';
        this.prevTarget = undefined;
        this.map.getViewport().style.cursor = 'grab';
        let vals = [];
        vals.push(this.tb1(), this.tb2(), this.tb3(), this.tb4(), this.tb5());
        if (this.tb6() != '') vals.push(this.tb6());

        if (this.modalTOEditor.value.PositionMouse && this.activeElement) {
          coord = this.activeElement.getGeometry().getClosestPoint(this.mousepos);
          fullcoord = coord;
          coord = toLonLat(coord);
          rotateAtEnd = true;
        }
        if (this.modalTOEditor.value.PositionCut && this.activeElement) {
          let pos =
            this.modalTOEditor.value.Position == '' ?
              geoDesLength(
                new LineString(
                  this.activeElement.getGeometry().getCoordinates()[0],
                  this.activeElement.getGeometry().getClosestPoint(this.mousepos)
                )
              )
            : this.modalTOEditor.value.Position;
          coord = this.cutLine(pos);
          fullcoord = fromLonLat(coord);
          rotateAtEnd = true;
        }

        let c: any = {};
        c.messwerte = vals;
        c.koordinaten = coord;
        c.name = this.selTOType;
        this.apiservice
          .setNewTOSymbol(c)
          .pipe()
          .subscribe((res: any) => {
            let src = this.topojsonLayer.getSource();
            let features = src.getFormat().readFeature(res, {
              featureProjection: 'EPSG:3857',
            });
            src.addFeature(features);

            if (rotateAtEnd) {
              let activeCoords = this.activeElement.getGeometry().clone().getCoordinates();
              let prevCoord = activeCoords[activeCoords.length - 1];
              for (let index = 0; index < activeCoords.length; index++) {
                const curcoords = activeCoords[index];
                if (curcoords[0] == fullcoord[0] && curcoords[1] == fullcoord[1]) {
                  prevCoord = index == 0 ? activeCoords[1] : activeCoords[index - 1];
                }
              }
              let a = this.GetBearing(prevCoord, fullcoord);
              a = a - 90 / (180 / Math.PI);
              res.properties.angle = a * (180 / Math.PI);
              features.getGeometry().rotate(a, fullcoord);
            }
            this.tempfeaturesList.push({ type: 'new_Symbol', feature: res });
          });

        this.modalTOEditor.value.PositionMouse = false;
        this.modalTOEditor.value.PositionCut = false;
        this.modalTOEditor.value.Position = undefined;
      }

      if (this.action() == 'getPos') {
        this.mouseposConv =
          this.mousepos[0].toFixed(2) + ', ' + this.mousepos[1].toFixed(2) + ' / ' + toLonLat(this.mousepos);
        this.action.set('');
        this.isGeoPosModalVisible = true;
      }

      if (this.action() == 'measure') {
        if (this.measure.SetSecondPoint) {
          this.map.removeInteraction(this.draw);
          this.action.set('');
          this.measure.Point2 = [this.mousepos[0].toFixed(2), this.mousepos[1].toFixed(2)];
          this.measure.Point2_Deg = toLonLat(this.mousepos);
          let line: LineString = new LineString([this.measure.Point1, this.measure.Point2]);
          this.measure.PointX = this.convertToUnit(
            parseFloat(this.measure.Point2[0]) - parseFloat(this.measure.Point1[0])
          );
          this.measure.PointY = this.convertToUnit(
            parseFloat(this.measure.Point2[1]) - parseFloat(this.measure.Point1[1])
          );
          this.measure.Distance = this.convertToUnit(geoDesLength(line));
          this.isGeoPosModalVisible = true;
        } else {
          this.measure.SetSecondPoint = true;
          this.measure.Point1 = [this.mousepos[0].toFixed(2), this.mousepos[1].toFixed(2)];
          this.measure.Point1_Deg = toLonLat(this.mousepos);
        }
      }
      if (this.action() == 'moveAll') {
        if (this.measure.SetSecondPoint) {
          this.map.removeInteraction(this.draw);
          this.action.set('');
          this.measure.Point2 = [this.mousepos[0].toFixed(2), this.mousepos[1].toFixed(2)];
          this.measure.Point2_Deg = toLonLat(this.mousepos);
          let line: LineString = new LineString([this.measure.Point1, this.measure.Point2]);
          this.measure.PointX = this.measure.Point2[0] - this.measure.Point1[0];
          this.measure.PointY = this.measure.Point2[1] - this.measure.Point1[1];
          this.measure.Distance = this.convertToUnit(geoDesLength(line));

          let src = this.topojsonLayer.getSource();
          let features = src.getFeatures();
          features.forEach(feat => {
            let newCoords = [];
            if (Array.isArray(feat.getGeometry().getCoordinates()[0])) {
              feat
                .getGeometry()
                .getCoordinates()
                .forEach(coord => {
                  coord[0] = coord[0] + this.measure.PointX;
                  coord[1] = coord[1] + this.measure.PointY;
                  newCoords.push(coord);
                });
              feat.getGeometry().setCoordinates(newCoords);
            } else {
              coord = feat.getGeometry().getCoordinates();
              coord[0] = coord[0] + this.measure.PointX;
              coord[1] = coord[1] + this.measure.PointY;
              feat.getGeometry().setCoordinates([coord[0], coord[1]]);
            }
            //this.tempfeaturesList.push({ type: 'edit_Feature', feature: feat.getProperties(), geom: feat.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates()})
          });
          this.topojsonLayer.setStyle(this.getLayerStyles());
        } else {
          this.measure.SetSecondPoint = true;
          this.measure.Point1 = [this.mousepos[0].toFixed(2), this.mousepos[1].toFixed(2)];
          this.measure.Point1_Deg = toLonLat(this.mousepos);
        }
      }

      if (this.prevTarget) {
        this.prevTarget.style.backgroundColor = '#F0F0F0';
        this.prevTarget = undefined;
        this.activeElement = undefined;
        this.modPointsLayer.getSource().clear();
        this.hoverSelect.getFeatures().clear();
        this.clickSelect.getFeatures().clear();
      }
    });

    this.clickSelect.on('select', e => {
      if (this.doshowFeatureMenu) return;
      if (this.multiSelect.getFeatures().getArray().length > 1) return;
      this.clickSelectLenght = undefined;
      this.activeElement = undefined;
      this.showdetailview = false;
      this.showprogressbar = false;
      this.ostammid = undefined;
      this.modPointsLayer.getSource().clear();
      this.clickSelect.getFeatures().clear();
      if (e.selected && e.selected.length > 0) {
        const sel = e.selected[0];
        const map = e.target.getMap();
        const id = sel.getProperties().OSTAMMID;
        const Delstatus = sel.getProperties().DelStatus;
        const rechte = sel.getProperties().Rechte;
        this.showprogressbar = true;
        this.selKilometerName.set('');
        const sellayer = sel.getProperties().layername;
        if (sellayer == 'objekttyp.1945') {
          const name = sel.getProperties().Name;
          const num = Number(name);
          const formattedName =
            name !== null && name !== undefined && name !== '' && !Number.isNaN(num) ?
              num.toLocaleString(undefined, {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })
            : name;

          this.popupElement.nativeElement.innerHTML = `<strong>KM ${formattedName ?? ''}</strong>`;
          const pos = sel.values_.geometry.flatCoordinates;

          this.popup.setPosition(pos);

          this.selKilometerName.set(sel.getProperties().name);
          return;
        }

        if (this.action() == 'draw') return;
        if (id > 0 && (Delstatus == 0 || Delstatus == undefined)) {
          this.rechte = rechte;
          const lastId = this.ostammid;
          this.ostammid = id;
          this.activeElement = sel;
          const extent = sel.getGeometry().getExtent();
          const view = map ? map.getView() : this.map.getView();

          const setx = (zoom: number) => {
            if (lastId == undefined && !this.altPressed) view.setZoom(zoom);
            this.clickSelect.getFeatures().push(sel);
            this.clickSelectLenght = geoDesLength(sel.values_.geometry).toFixed(2) + ' m';
            this.mapZoomed$.next(true);
            this.updateMapSize();
          };

          if (
            !sel.getProperties().layername.includes('stamm.bauwerke') &&
            !sel.getProperties().layername.includes('stamm.naturschutz') &&
            !this.altPressed
          ) {
            if (sel.getGeometry().getType() == 'Point') {
              view.fit(extent, {
                duration: 500,
                maxZoom: 20,
                callback: () => setx(view.getZoom()),
              });
            } else {
              view.fit(extent, {
                duration: 500,
                maxZoom: 19,
                padding: [50, 100, 50, 100],
                callback: () => setx(view.getZoom() - 1),
              });
            }
          } else {
            this.clickSelect.getFeatures().push(sel);
            this.clickSelectLenght = geoDesLength(sel.values_.geometry).toFixed(2) + ' m';
          }

          this.hoverSelect.getFeatures().clear();
        } else {
          this.activeElement = sel;
          this.clickSelect.getFeatures().push(sel);
          this.mapZoomed$.next(true);
          this.updateMapSize();
          this.hoverSelect.getFeatures().clear();

          this.clickSelectLenght = geoDesLength(sel.values_.geometry).toFixed(2) + ' m';
        }
      } else {
        this.progressbars = {};
        if (this.activeElement) this.clickSelect.getFeatures().push(this.activeElement);
      }
    });

    this.map.getInteractions().push(this.clickSelect);
    this.map.getInteractions().push(this.hoverSelect);
    this.map.getInteractions().push(dragBox);
    this.map.getInteractions().push(this.multiSelect);

    //Cursor Grabber & Pointer
    this.hoverSelect.on('select', e => {
      if (this.action() != '' && this.action() != undefined) {
        this.map.getViewport().style.cursor = 'crosshair';
      } else if (e.selected.length > 0) {
        this.map.getViewport().style.cursor = 'crosshair';
      } else {
        this.map.getViewport().style.cursor = 'crosshair';
        this.infoStyle.set('visibility:hidden');
      }
    });

    this.map.getViewport().style.cursor = 'crosshair';
    this.map.on('pointerdrag', function (evt) {
      evt.target.getViewport().style.cursor = 'crosshair';
    });
    this.map.on('pointerup', function (evt) {
      evt.target.getViewport().style.cursor = 'crosshair';
    });

    // Basemap on
    if (Object.keys(this.baseLayer).length == 0) {
      if (localStorage.getItem('theme') == 'dark') {
        this.tileSwitch('cartoDB', 'cartoDbDark');
      } else {
        this.tileSwitch('cartoDB', 'cartoDbLight');
      }
    } else {
      this.tileSwitch(this.baseLayer[0], this.baseLayer[1]);
    }

    if (storeddata?.baseLayer && storeddata?.baseLayer != this.baseLayer) {
      this.tileSwitch(storeddata.baseLayer[0], storeddata.baseLayer[1]);
    }

    // handle geolocation error.
    this.geolocation.on('error', function (error) {
      console.log(error.message);
    });

    dragBox.on('boxend', e => {
      const boxExtent = dragBox.getGeometry().getExtent();

      // if the extent crosses the antimeridian process each world separately
      const worldExtent = e.mapBrowserEvent.map.getView().getProjection().getExtent();
      const worldWidth = getWidth(worldExtent);
      const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
      const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);

      for (let world = startWorld; world <= endWorld; ++world) {
        const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
        const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
        const extent = [left, boxExtent[1], right, boxExtent[3]];

        let boxFeatures = this.topojsonLayer
          .getSource()
          .getFeaturesInExtent(extent)
          .filter(feature => feature.getGeometry().intersectsExtent(extent));
        boxFeatures = boxFeatures.concat(
          this.polygonLayer
            .getSource()
            .getFeaturesInExtent(extent)
            .filter(feature => feature.getGeometry().intersectsExtent(extent))
        );

        const rotation = e.mapBrowserEvent.map.getView().getRotation();
        const oblique = rotation % (Math.PI / 2) !== 0;

        if (oblique) {
          const anchor = [0, 0];
          const geometry = dragBox.getGeometry().clone();
          geometry.translate(-world * worldWidth, 0);
          geometry.rotate(-rotation, anchor);
          const extent = geometry.getExtent();
          boxFeatures.forEach(function (feature) {
            const geometry = feature.getGeometry().clone();
            geometry.rotate(-rotation, anchor);
            if (geometry.intersectsExtent(extent)) {
              this.multiSelect.selectFeature(feature);
            }
          });
        } else {
          boxFeatures.forEach(x => this.multiSelect.selectFeature(x));
        }
      }
    });

    // clear selection when drawing a new box and when clicking on the map
    dragBox.on('boxstart', function () {
      if (this.multiSelect) this.multiSelect.clearSelection();
    });

    combineLatest([this.mapready$, this.topojsonready$])
      .pipe(
        filter(([mapready, topojsonready]) => mapready && topojsonready),
        first(),
        delay(200)
      )
      .subscribe(() => {
        console.debug('mapready and topojsonready');

        this.getStrValues(storeddata?.overLayer ?? undefined);
        let features = this.topojsonLayer.getSource().getFeatures();
        features = features.concat(this.polygonLayer.getSource().getFeatures());
        const storedElement = storeddata?.activeElement as Feature<Geometry>;
        const queryElement = this.route.snapshot.queryParams['ostammid'] as number;

        const activeElement =
          queryElement ?
            features.find(feature => {
              const props = feature.getProperties();
              return props?.layername?.includes('objekttyp') && props.OSTAMMID == queryElement;
            })
          : !storedElement ? undefined
          : features.find(feature => {
              const props = feature.getProperties();
              return (
                props?.layername &&
                props.layername == storedElement.getProperties().layername &&
                props.OSTAMMID == storedElement.getProperties().OSTAMMID
              );
            });

        if (activeElement == undefined && queryElement != undefined) {
          this.toastr.warning(this.mrTranslate.transform('Objekt konnte nicht in der Karte gefunden werden'));
        }

        if (!view && !activeElement) {
          this.map.getView().fit(this.topojsonLayer.getSource().getExtent(), {
            duration: 500,
            padding: [50, 50, 50, 50],
            callback: () => {
              this.mapZoomed$.next(true);
            },
          });
        } else if (activeElement) {
          this.selectFeature(activeElement);
        }

        this.setupSearch();
      });
  }

  showFeatureMenu(pixel: number[], features: any[]): void {
    const menu = document.getElementById('feature-menu') as HTMLDivElement | null;

    if (!menu) {
      return;
    }

    menu.innerHTML = '';

    features.forEach((feature, index) => {
      const item = document.createElement('div');

      item.className = 'feature-menu-item';

      let prop = feature.getProperties();

      const name = prop.Name;
      const key = prop.SYSICON > 0 ? `objekttyp${prop.SYSICON}` : 'GM_Typ_0';
      const pfad = `assets/icons/${key}.svg`;
      const icon = document.createElement('img');
      icon.src = pfad;
      icon.className = 'feature-menu-icon';
      const label = document.createElement('span');
      label.textContent = name;

      item.appendChild(icon);
      item.appendChild(label);

      item.addEventListener('click', () => {
        this.doshowFeatureMenu = false;
        this.selectFeature(feature);
        this.closeFeatureMenu();
      });

      menu.appendChild(item);
    });

    menu.style.left = `${pixel[0]}px`;
    menu.style.top = `${pixel[1]}px`;
    menu.style.display = 'block';
  }

  closeFeatureMenu(): void {
    const menu = document.getElementById('feature-menu') as HTMLDivElement | null;

    if (!menu) {
      return;
    }

    menu.style.display = 'none';
    this.doshowFeatureMenu = false;
  }

  private setupSearch() {
    const click = this.clickSelect;
    // Set the control grid reference
    const placeholdertext = this.mrTranslate.transform('Suche') + '...';
    let search = new SearchFeature({
      label: 'Objektsuche',
      placeholder: placeholdertext,
      //target: $(".options").get(0),
      //property: $(".options select").val(),
      property: 'Bezeichnung',
      sort: function (f1, f2) {
        if (search.getSearchString(f1) < search.getSearchString(f2)) return -1;
        if (search.getSearchString(f1) > search.getSearchString(f2)) return 1;
        return 0;
      },
      getSearchString(f) {
        return f?.getProperties()?.Bezeichnung || '';
      },
    });
    search.setSource(this.topojsonLayer.getSource());

    this.map.addControl(search);

    // Select feature when click on the reference index
    search.on('select', e => {
      const feature = e.search;
      let map = e.target.getMap() as OlMap;

      click.getFeatures().clear();
      let lastId = this.ostammid;
      this.ostammid = feature.getProperties().OSTAMMID;

      let extent = feature.getGeometry().getExtent();
      let view = map.getView();
      let zoomto = () => {
        view.fit(extent, {
          duration: 500,
          maxZoom: 19,
          padding: [50, 100, 50, 100],
          callback: () => {
            if (lastId == undefined) view.setZoom(view.getZoom() - 1);
            click.getFeatures().push(feature);
          },
        });
      };
      zoomto();
    });
  }

  ngAfterViewInit(): void {
    this.tempDisable = false;
    this.apiservice
      .getSettingsApiKeys()
      .pipe()
      .subscribe((apikeys: any) => {
        this.initMap(apikeys);
        this.unitLength = this.basicStore.getComponentStore('einstellung')?.einstellung?.optUnitLength ?? 0;
      });
  }

  setDateFilter(dateFilterObj: any) {
    this.datefilter = dateFilterObj;
    this.topojsonLayer.setStyle(this.getLayerStyles());
  }

  restoreMapState(storeddata) {
    if (storeddata) {
      const routeHasOstammid = this.route.snapshot.queryParams['ostammid'] !== undefined;

      if (storeddata['showdetailview']) {
        this.showdetailview = storeddata['showdetailview'];
      }
      if (storeddata['hidedetailview']) {
        this.hidedetailview = storeddata['hidedetailview'];
      }

      if (storeddata['ostammid']) {
        if (this.showdetailview) {
          this.ostammid = storeddata['ostammid'];
        } else {
          this.ostammid = undefined;
        }
      }

      if (storeddata['baseLayer'] && storeddata['baseLayer'] != this.baseLayer) {
        this.tileSwitch(storeddata['baseLayer'][0], storeddata['baseLayer'][1]);
      }

      if (!routeHasOstammid && storeddata['activeElement']) {
        this.activeElement = undefined;
        const features = this.topojsonLayer.getSource().getFeatures();
        const elemProps = storeddata['activeElement'].getProperties();
        const feature = features.find(feature => {
          const props = feature.getProperties();
          return props?.layername && props.layername == elemProps.layername && props.OSTAMMID == elemProps.OSTAMMID;
        });

        if (feature) {
          this.selectFeature(feature);
        }
      } else if (!routeHasOstammid && storeddata['view']) {
        const savedView = storeddata['view'];
        const view = this.map.getView();
        view.setCenter(savedView.getCenter());
        view.setZoom(savedView.getZoom());
        view.setRotation(savedView.getRotation());
      }

      if (storeddata['sidenavenlarged']) {
        this.sidenavenlarged = storeddata['sidenavenlarged'];
      }
      if (storeddata['progressbarenlarged']) {
        this.progressbarenlarged = storeddata['progressbarenlarged'];
      }
      if (storeddata['split50']) {
        this.split50 = storeddata['split50'];
      }

      document.querySelector('.ol-viewport').dispatchEvent(new MouseEvent('mousemove'));
    }
  }

  getStrValues(overlays, useExistingObjSettings: boolean = false) {
    this.apiservice
      .getKarteStrValues()
      .pipe()
      .subscribe((strValues: any) => {
        Object.keys(strValues).forEach(strVal => {
          let cat, ovrl;
          if (strVal == 'objekttyp') {
            let objTypes = strValues[strVal];
            if (objTypes?.length > 0 && !useExistingObjSettings) {
              this.overLayers.base[0].overlays = objTypes.map(type => {
                let key = `objekttyp.${type.OTYPID}`;
                this.vectorLayerNames.push(key);
                return {
                  name: type.Bezeichnung,
                  key: key,
                  icon: type.icon,
                  enable: false,
                  color: 'black',
                };
              });
            }
            return;
          }
          if (strVal == 'fehlerklassen') {
            let objTypes = strValues['fehlerklassen'];
            if (objTypes?.length > 0) {
              this.overLayers.base[1].overlays = objTypes.map(type => {
                let key = `minfk.${type.val.slice(13)}`;

                return {
                  name: type.val,
                  key: key,
                  enable: false,
                  color: type.color,
                };
              });

              this.overLayers.base[2].overlays = objTypes.map(type => {
                let key = `maengel.${type.val.slice(13)}`;

                return {
                  name: type.val,
                  key: key,
                  enable: false,
                  color: type.color,
                };
              });
            }
          }

          if (strVal == 'railprofiles') {
            let objTypes = strValues[strVal];
            if (objTypes?.length > 0) {
              this.hasrailprofiles = true;

              this.apiservice
                .getRailProfiles()
                .pipe()
                .subscribe((val: any) => {
                  if (val.success) {
                    this.railprofiles = val.data.rows;
                    this.railprofilescolors = val.colors;
                  } else {
                    this.hasrailprofiles = false;
                  }
                });
            }
          }

          if (strVal.includes('.')) {
            let strArr = strVal.split('.');
            cat = strArr[0].toLowerCase();
            ovrl = strArr[1];
          } else {
            cat = strVal;
            ovrl = strVal;
          }

          if (!this.overLayers.visualisations[cat]) {
            this.overLayers.visualisations[cat] = [];
          }

          let catName = ovrl.charAt(0).toUpperCase() + ovrl.slice(1);
          let ind = -1;
          for (let e = 0; e < this.overLayers.visualisations[cat].length; e++) {
            if (
              this.overLayers.visualisations[cat][e]?.category &&
              this.overLayers.visualisations[cat][e].category == catName
            ) {
              ind = e;
              break;
            }
          }

          if (ind == -1) {
            this.overLayers.visualisations[cat].push({
              category: catName,
              overlays: [],
            });
            ind = this.overLayers.visualisations[cat].length - 1;
          }

          this.overLayers.visualisations[cat][ind].overlays = [];
          strValues[strVal].forEach((keyEl: any) => {
            let key = (strVal + '.' + keyEl.val).trim();
            this.overLayers.visualisations[cat][ind].overlays.push({
              name: keyEl.val,
              key: key,
              enable: false,
              color: keyEl.color,
            });
            this.visuColors[key] = keyEl.color;
            this.vectorLayerNames.push(key);
          });
        });

        dbS.getGISKilometrierung(localStorage.getItem('DB') + this.curMapSet).then(x => {
          if (x) {
            this.kilometrierung = x;

            const newItem = {
              name: 'Kilometrierung',
              key: 'objekttyp.1945',
              icon: 1945,
              enable: true,
              color: 'black',
            };

            const overlays = this.overLayers.base[0].overlays;
            if (!overlays.some(item => item.key === newItem.key)) {
              overlays.push(newItem);
            }
            this.overLayers.base[0].overlays.sort((a, b) => a.name.localeCompare(b.name));

            const overlaysSort = this.overLayers.base[0].overlays;

            const index = overlaysSort.findIndex(item => item.key === 'objekttyp.0');

            if (index !== -1) {
              overlaysSort.push(overlaysSort.splice(index, 1)[0]);
            }
          }
        });

        if (overlays && overlays.length > 0) {
          overlays.forEach((overlay: any) => {
            this.changeOverlayState(overlay[0], overlay[1], overlay[2], true);
          });
        }

        for (let i = 0; i < this.overLayers.base[0].overlays.length; i++) {
          this.changeOverlayState('base', 0, i, useExistingObjSettings ? this.overLayers.base[0].overlays[i].enable : true);
        }
      });
  }

  colorFocusInput(input: HTMLElement, ol, i, j) {
    this.ol = {
      key: ol.key.substring(0, ol.key.indexOf('.')),
      color: ol.color,
      i: i,
      j: j,
    };
    setTimeout(() => {
      input.focus();
      input.click();
    }, 20);
  }

  leaveColorFocus(event) {
    if (!event && this.curColor) {
      this.apiservice
        .setKColor(this.curColor)
        .pipe()
        .subscribe((res: any) => {});
    }
  }

  setColorFromPicker(group: string, i: number, j: number, event) {
    let ol = this.overLayers.base;
    this.ol.color = event;
    if (group != 'base') {
      ol = this.overLayers.visualisations[group];
    }

    let key = ol[i].overlays[j].key;
    this.visuColors[key] = event;
    ol[i].overlays[j].color = event;

    this.curColor = {
      color: event,
      wert: key,
    };

    this.topojsonLayer.setStyle(this.getLayerStyles());
  }

  protected async colorChanged({ color, key }: Overlay) {
    this.visuColors[key] = color;
    this.topojsonLayer.setStyle(this.getLayerStyles());
    try {
      await firstValueFrom(this.apiservice.setKColor({ color, wert: key }));
    } catch (er) {
      console.error('color Change Save: ', er);
    }
  }
  setColorGeneral(type: string, event) {
    this[type] = event;
    this.topojsonLayer.setStyle(this.getLayerStyles());
    this.persistanceService.set('karteFarbe', {
      bC: this.baseColor,
      hC: this.hoverColor,
      hEC: this.hoverEmptyColor,
    });
  }

  resetColor() {
    let dark =
      this.baseLayer[1] == 'cartoDbDark' ||
      this.baseLayer[1] == 'cartoDbDarkNoLabels' ||
      this.baseLayer[1] == 'mapboxDark';
    this.baseColor = dark ? 'rgba(170,170,170,0.6)' : 'rgba(0,0,0,0.6)';
    this.hoverColor = '#fe5d00';
    this.hoverEmptyColor = '#FEAC88';
    this.topojsonLayer.setStyle(this.getLayerStyles());
    this.persistanceService.set('karteFarbe', {
      bC: this.baseColor,
      hC: this.hoverColor,
      hEC: this.hoverEmptyColor,
    });
  }

  applyFilter(event) {
    this.objectFilter = event;
    this.topojsonLayer.setStyle(this.getLayerStyles());
  }

  invertFilter(event) {
    this.filter_invert = event;
    this.topojsonLayer.setStyle(this.getLayerStyles());
  }

  setMessFilter(event) {
    this.spinner.enable();
    this.isGleisMessFilterReady = false;
    this.gleisMessFilter = event;
    this.visumode = ['measurements', 0];
    this.disableAllOverlays(this.visumode);
    this.gleisMessLayer.getSource().refresh();
  }

  async switchRepFilter(event) {
    let checked: boolean = event.target.checked;
    this.reset();
    const src = this.topojsonLayer.getSource();
    try {
      src.clear();
      const x: FeatureCollection =
        (await dbS.getGIS(localStorage.getItem('DB') + this.curMapSet)) ?? (await this.apiservice.getTopoJson());
      let features = src.getFormat().readFeatures(x, {
        featureProjection: 'EPSG:3857',
      });
      if (checked) {
        const filtered = await this.repDB.filterGisMAP(features);
        src.addFeatures(filtered);
      } else {
        src.addFeatures(features);
      }
      this.topojsonready$.next(true);
    } catch (er) {}
  }

  getLayerStyles() {
    return (feature, resolution) => {
      let prop = feature.getProperties();

      if (this.objectFilter && this.objectFilter.length > 0) {
        if (this.filter_invert) {
          if (!prop.OSTAMMID || this.objectFilter.includes(prop.OSTAMMID)) {
            return null;
          }
        } else if (!this.objectFilter.includes(prop.OSTAMMID)) {
          return null;
        }
      }

      let show = false;
      if (prop.layername) {
        let isBaseLayer = prop.layername.includes('objekttyp.');
        if (!isBaseLayer) {
          let otypid = prop.OTYPID;
          let typOvrl = this.overLayers.base[0].overlays.find(ovrl => ovrl.key.includes(otypid)) || undefined;
          let showOTYPID = typOvrl?.enable;
          if (!showOTYPID) return null;
        }

        // Multi-layernames mit komma getrennt, wie z.B. bei Herstellern
        if (prop.layername.includes(',') && this.visuColors) {
          let multi = prop.layername.split(',');
          show = false;
          let color = '#800080';
          for (const element of multi) {
            if (!show && !this.vectorLayerNames.includes(element)) {
              color = this.visuColors[element];
              show = !!color;
              break;
            }
          }
          if (!show) {
            return null;
          } else if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
            this.elementStyles.line.getStroke().setColor(color);
            this.elementStyles.line.getStroke().setLineDash([]);
            this.elementStyles.line.setZIndex(1);
            this.objSetText(prop, this.elementStyles.line);
            return this.elementStyles.line;
          } else {
            this.elementStyles.point.setImage(
              new Icon({
                src: 'assets/icons/GM_Typ_0.svg',
                scale: 0.2 / resolution,
                rotation: prop.angle,
                color: color,
              })
            );
            return this.elementStyles.point;
          }
        } else {
          let ind = this.vectorLayerNames.indexOf(prop.layername);
          if (ind != -1) {
            return null;
          }
        }

        //Basislayer
        if (isBaseLayer) {
          if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
            this.elementStyles.line.getStroke().setColor(this.baseColor);
            this.elementStyles.line.getStroke().setLineDash([]);
            this.elementStyles.line.setZIndex(0);
            this.objSetText(prop, this.elementStyles.line);
            return this.elementStyles.line;
          }

          if (prop.geometry.getType() == 'Point' && prop.PointID) {
            let smallIcon =
              prop.PointID == '0' ||
              prop.PointID == '5' ||
              prop.PointID == '23' ||
              (prop.PointID >= '30' && prop.PointID <= '41');

            let pfad = `assets/icons/GM_Typ_${prop.PointID}.svg`;

            if (prop.PointID == '0' && prop.SYSICON > 0) {
              const key = `objekttyp${prop.SYSICON}`;
              pfad = `assets/icons/${key}.svg`;
            }

            let imagestl = new Icon({
              src: pfad,
              scale:
                this.shiftPressed ? 1
                : smallIcon ? 0.2 / resolution
                : 0.3 / resolution,
              rotation: prop.angle,
              anchor: smallIcon ? [0.5, 0.5] : [0.5, 1],
              color: this.baseColor,
            });
            this.elementStyles.point.setImage(imagestl);
            this.objSetText(prop, this.elementStyles.point);
            return this.elementStyles.point;
          }
          if (prop.geometry.getType() == 'Polygon') {
            this.elementStyles.polygon.getStroke().setColor(this.baseColor);
            this.elementStyles.polygon.getStroke().setLineDash([]);
            this.elementStyles.polygon.setZIndex(prop.toSetBack ? -99 : 1);
            this.elementStyles.polygon.getFill().setColor('rgba(0, 0, 255, 0.2)');
            this.objSetText(prop, this.elementStyles.polygon);
            return this.elementStyles.polygon;
          }

          if (prop.geometry.getType() == 'Point' && prop.OSTAMMID > 1) {
            const key = prop.SYSICON > 0 ? `objekttyp${prop.SYSICON}` : 'GM_Typ_0';
            const pfad = `assets/icons/${key}.svg`;

            this.elementStyles.point.setImage(
              new Icon({
                src: pfad,
                scale: 0.2 / resolution,
                rotation: prop.angle,
                color: this.baseColor,
              })
            );

            this.objSetText(prop, this.elementStyles.point);
            return this.elementStyles.point;
          }

          return null;
        }

        // Andere Layer (z.B. Visualisierungen)
        if (prop.layername.includes('maengel') || prop.layername.includes('minfk')) {
          let errorNum = prop.layername.match(/\d+/)[0];
          let color = this.visuColors['fehlerklassen.Fehlerklasse ' + errorNum];
          if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
            // Wenn "Linienobjekte deaktiviert: keine Linien Visus rendern"
            this.elementStyles.line.getStroke().setColor(color);
            this.elementStyles.line.getStroke().setLineDash([]);
            this.elementStyles.line.setZIndex(6 - errorNum);
            this.objSetText(prop, this.elementStyles.line);
            return this.elementStyles.line;
          } else {
            // Wenn "Punktobjekte deaktiviert: keine Punkte Visus rendern"
            
            let pfad = 'assets/icons/GM_Typ_0.svg';

            if (prop.SYSICON > 0) {
              const key = `objekttyp${prop.SYSICON}`;
              pfad = `assets/icons/${key}.svg`;
            }
            
            this.elementStyles.point.setImage(
              new Icon({
                src: pfad,
                scale: 0.2 / resolution,
                rotation: prop.angle,
                color: color,
              })
            );

            return this.elementStyles.point;
          }
        }
        if (
          prop.layername.includes('stoerungen') ||
          prop.layername.includes('stamm') ||
          prop.layername.includes('sperrungen') ||
          prop.layername.includes('langsamfahrstellen') ||
          prop.layername.includes('trassierungen') ||
          prop.layername.includes('prueftermin') ||
          prop.layername.includes('termin.') ||
          prop.layername.includes('auftraege') ||
          prop.layername.includes('kaveinfach') ||
          prop.layername.includes('kavseg') ||
          prop.layername.includes('sonstige') ||
          prop.layername.includes('projekte')
        ) {
          let col = this.visuColors[prop.layername];
          if (!col) {
            return null;
          }

          if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
            this.elementStyles.line.getStroke().setColor(col);
            this.elementStyles.line.getStroke().setLineDash([]);
            this.elementStyles.line.setZIndex(1);
            this.objSetText(prop, this.elementStyles.line);

            if (this.showMangelBem && prop.Bemerkung) {
              this.elementStyles.line.getStroke().setColor('red');
              this.elementStyles.line.getStroke().setLineDash([6, 6]);
              this.elementStyles.line.setZIndex(6);
            }

            return this.elementStyles.line;
          } else {
            let pfad = 'assets/icons/GM_Typ_0.svg';

            if (prop.SYSICON > 0) {
              const key = `objekttyp${prop.SYSICON}`;
              pfad = `assets/icons/${key}.svg`;
            }

            this.elementStyles.point.setImage(
              new Icon({
                src: pfad,
                scale: 0.2 / resolution,
                rotation: prop.angle,
                color: col,
              })
            );
            return this.elementStyles.point;
          }
        }
        return null;
      }
    };
  }

  downloadBlob(blob: Blob, filename: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  // ============================
  // PRJ per EPSG
  // ============================
  getPrjByEPSG(exEPSG: string): string {
    switch (exEPSG) {
      //WGS 84 World
      case 'EPSG:4326':
        return `GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]`;
      //Swiss CH1903 + / LV95
      case 'EPSG:2056':
        return `GEOGCS["CH1903+", DATUM["CH1903+", SPHEROID["Bessel 1841",6377397.155,299.1528128], TOWGS84[674.374,15.056,405.346,0,0,0,0]], PRIMEM["Greenwich",0], UNIT["degree",0.0174532925199433]]`;
      //Swiss CH1903 / LV03
      case 'EPSG:21781':
        return `GEOGCS["CH1903", DATUM["CH1903", SPHEROID["Bessel 1841",6377397.155,299.1528128]], PRIMEM["Greenwich",0], UNIT["degree",0.0174532925199433]]`;
      //ETRS89 / UTM zone 31N
      case 'EPSG:25831':
        return `GEOGCS["ETRS89", DATUM["European_Terrestrial_Reference_System_1989", SPHEROID["GRS 1980",6378137,298.257222101, AUTHORITY["EPSG","7019"]], TOWGS84[0,0,0,0,0,0,0], AUTHORITY["EPSG","6258"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4258"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",3], PARAMETER["scale_factor",0.9996], PARAMETER["false_easting",500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AXIS["Easting",EAST], AXIS["Northing",NORTH], AUTHORITY["EPSG","25831"]`;
      //ETRS89 / UTM zone 32N
      case 'EPSG:25832':
        return `GEOGCS["ETRS89", DATUM["European_Terrestrial_Reference_System_1989", SPHEROID["GRS 1980",6378137,298.257222101, AUTHORITY["EPSG","7019"]], TOWGS84[0,0,0,0,0,0,0], AUTHORITY["EPSG","6258"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4258"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",9], PARAMETER["scale_factor",0.9996], PARAMETER["false_easting",500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AXIS["Easting",EAST], AXIS["Northing",NORTH], AUTHORITY["EPSG","25832"]`;
      //ETRS89 / UTM zone 33N
      case 'EPSG:25833':
        return `GEOGCS["ETRS89", DATUM["European_Terrestrial_Reference_System_1989", SPHEROID["GRS 1980",6378137,298.257222101, AUTHORITY["EPSG","7019"]], TOWGS84[0,0,0,0,0,0,0], AUTHORITY["EPSG","6258"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4258"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",15], PARAMETER["scale_factor",0.9996], PARAMETER["false_easting",500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AXIS["Easting",EAST], AXIS["Northing",NORTH], AUTHORITY["EPSG","25833"]`;
      //Gauss-Kruger Zone 2 (Mittelmeridiane 6 Grad)
      case 'EPSG:31466':
        return `GEOGCS["DHDN", DATUM["Deutsches_Hauptdreiecksnetz", SPHEROID["Bessel 1841",6377397.155,299.1528128], EXTENSION["PROJ4_GRIDS","de_adv_BETA2007.tif"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4314"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",6], PARAMETER["scale_factor",1], PARAMETER["false_easting",2500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","31466"]`;
      //Gauss-Kruger Zone 3 (Mittelmeridiane 9 Grad)
      case 'EPSG:31467':
        return `GEOGCS["DHDN", DATUM["Deutsches_Hauptdreiecksnetz", SPHEROID["Bessel 1841",6377397.155,299.1528128], EXTENSION["PROJ4_GRIDS","de_adv_BETA2007.tif"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4314"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",9], PARAMETER["scale_factor",1], PARAMETER["false_easting",3500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","31467"]`;
      //Gauss-Kruger Zone 4 (Mittelmeridiane 12 Grad)
      case 'EPSG:31468':
        return `GEOGCS["DHDN", DATUM["Deutsches_Hauptdreiecksnetz", SPHEROID["Bessel 1841",6377397.155,299.1528128], EXTENSION["PROJ4_GRIDS","de_adv_BETA2007.tif"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4314"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",12], PARAMETER["scale_factor",1], PARAMETER["false_easting",4500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","31468"]`;
      //Gauss-Kruger Zone 5 (Mittelmeridiane 15 Grad)
      case 'EPSG:31469':
        return `GEOGCS["DHDN", DATUM["Deutsches_Hauptdreiecksnetz", SPHEROID["Bessel 1841",6377397.155,299.1528128], EXTENSION["PROJ4_GRIDS","de_adv_BETA2007.tif"]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4314"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",15], PARAMETER["scale_factor",1], PARAMETER["false_easting",5500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","31469"]`;
      //Belge 1972 / Belgian Lambert 72
      case 'EPSG:31370':
        return `GEOGCS["BD72", DATUM["Reseau_National_Belge_1972", SPHEROID["International 1924",6378388,297], TOWGS84[-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4313"]], PROJECTION["Lambert_Conformal_Conic_2SP"], PARAMETER["latitude_of_origin",90], PARAMETER["central_meridian",4.36748666666667], PARAMETER["standard_parallel_1",51.1666672333333], PARAMETER["standard_parallel_2",49.8333339], PARAMETER["false_easting",150000.013], PARAMETER["false_northing",5400088.438], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AXIS["Easting",EAST], AXIS["Northing",NORTH], AUTHORITY["EPSG","31370"]`;

      default:
        return `GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]`;
    }
  }

  async generateDownloadUri(format) {
    const geojson_Format = new GeoJSON();
    let exEPSG = this.curEPSG;
    const mapLayers = this.map.getLayers().getArray();
    //const features_: any[] = [];
    const features_: GeoJSONFeature<GeoJSONGeometry, Record<string, any>>[] = [];
    let thisoverLayers = { ...this.overLayers };

    if (format === 'pdf') exEPSG = 'EPSG:25832';
    if (format === 'kml') exEPSG = 'EPSG:4326';

    mapLayers.forEach(layer => {
      if (layer instanceof OlVectorLayer) {
        let layerFeatures = layer.getSource().getFeatures();
        layerFeatures.forEach(feature => {
          const geom = feature.getGeometry();
          if (geom) {
            const cloneGeom = geom.clone();
            cloneGeom.transform('EPSG:3857', exEPSG);

            let layername = feature.values_.layername;
            if (!layername.toString().toLowerCase().includes('objekttyp')) {
              // 🧹 Properties bereinigen
              const plainProps: Record<string, any> = {};

              Object.entries(feature.getProperties()).forEach(([key, value]) => {
                if (key === 'geometry') return;

                if (value === undefined || value === null) {
                  plainProps[key] = '';
                } else if (typeof value === 'number' || typeof value === 'string' || typeof value === 'boolean') {
                  plainProps[key] = value;
                } else {
                  // komplexe Objekte serialisieren
                  plainProps[key] = JSON.stringify(value);
                }
              });

              const geometryObject = geojson_Format.writeGeometryObject(cloneGeom);
              if (geometryObject) {
                features_.push({
                  type: 'Feature',
                  geometry: geometryObject,
                  properties: plainProps,
                });
              }
            }
          }
        });
      }
    });

    const curGeoJson: FeatureCollection<GeoJSONGeometry, Record<string, any>> = {
      type: 'FeatureCollection',
      features: features_,
    };

    if (format === 'kml') {
      const geojsonFormat = new GeoJSON();

      // Wrap features in a FeatureCollection
      const featureCollection = {
        type: 'FeatureCollection',
        features: features_, // your array of GeoJSON features
      };

      // Convert all GeoJSON features to OL features
      const olFeatures: Feature<Geometry>[] = geojsonFormat.readFeatures(featureCollection, {
        featureProjection: 'EPSG:3857',
      });

      const kmlFormat = new KML();

      let kmlString = `<kml xmlns="http://www.opengis.net/kml/2.2"><Document>`;

      olFeatures.forEach((feature, idx) => {
        feature.setId(idx);
        let lnames = feature.getProperties().layername.toString().split('.');
        let group = lnames[0];
        let cat = lnames[1];

        if (group == 'maengel' || group == 'minfk') {
          switch (cat) {
            case '1':
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#ff0000', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
            case '2':
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#ffff00', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
            case '3':
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#00ff00', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
            case '4':
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#0000ff', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
            case '10':
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#030303', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
            default:
              feature.setStyle(
                new OlStyle({
                  stroke: new Stroke({
                    color: '#000000', // alternating colors
                    width: 2,
                  }),
                })
              );
              break;
          }
        } else {
          let name = lnames[2];
          if (name.includes('bauform')) {
            let n = name.split(',');
            name = n[0];
          }
          let ol = thisoverLayers.visualisations[group];
          let curoverlays = ol.find(x => x.category.toLowerCase() === cat.toLowerCase()).overlays;

          try {
            let color = curoverlays.find(x => x.name.toLowerCase() === name.toLowerCase()).color!;
            feature.setStyle(
              new OlStyle({
                stroke: new Stroke({
                  color: color, // alternating colors
                  width: 2,
                }),
              })
            );
          } catch {
            console.log(name);
          }
        }
        const node = kmlFormat.writeFeaturesNode([feature], {
          featureProjection: 'EPSG:3857',
        });
        const serializer = new XMLSerializer();
        const featureXml = serializer.serializeToString(node);

        const placemarkMatch = featureXml.match(/<Placemark[\s\S]*?<\/Placemark>/);
        if (placemarkMatch) {
          kmlString += placemarkMatch[0];
        }
      });

      kmlString += `</Document></kml>`;

      const blob = new Blob([kmlString], {
        type: 'application/vnd.google-earth.kml+xml',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'mrpro-gis-export.kml';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      return;
    }

    if (format === 'shp') {
      const fc: FeatureCollection = {
        type: 'FeatureCollection',
        features: features_,
      };

      const exporter = new GeoJSONExporter();
      await exporter.exportGeoJSON(fc, {
        exEPSG: exEPSG,
        filename: 'mrpro-gis-export.zip',
      });

      return;
    }

    if (this.selBauform != undefined) {
      let bauform = this.selBauform;
      curGeoJson.features.forEach(feature => {
        let n = feature.properties.layername.split(',');
        bauform.overlays.forEach(overlay => {
          n.forEach(key => {
            if (key == overlay.key) {
              feature.properties.layername = overlay.key;
            }
          });
        });
      });
    }

    let colAnz = 'NoP_GC_15';
    let colLen = 'Dis_GC_15';

    try {
      if (curGeoJson.features[0].properties.layername.includes('railprofiles')) {
        let colnum = ((this.vauleGrinding * 10) / 100).toString().split('.')[1];
        if (colnum.length == 1) {
          colnum = colnum + '0';
        }
        colAnz = 'NoP_GC_' + colnum;
        colLen = 'Dis_GC_' + colnum;
      }
    } catch (e) {
      console.log((e as Error).message);
    }

    curGeoJson.features.forEach(function (feature) {
      let lnames = feature.properties.layername.toString().split('.');
      let group = lnames[0];
      let cat = lnames[1];

      if (group == 'railprofiles') {
        let newproperties = {
          ID: feature.properties.OSTAMMID,
          color: feature.properties.color,
          gauge_mm: feature.properties.Spur.toFixed(1),
          section_start_m: feature.properties.StartPosition,
          section_end_m: feature.properties.EndPosition,
          average_ware_left_rail_mm: feature.properties.disfkL,
          average_ware_right_rail_mm: feature.properties.disfkR,
          profile: feature.properties.profil,
          length_section_m: feature.properties.Distance,
          NumberofPasses_piece: feature.properties[colAnz],
          LengthofProcessing_m: feature.properties[colLen],
        };

        feature.properties = newproperties;
      } else {
        let name = lnames[2];
        let ol = thisoverLayers.base;

        if (group == 'maengel' || group == 'minfk') {
          switch (cat) {
            case '1':
              feature.properties.color = '#ff0000';
              break;
            case '2':
              feature.properties.color = '#ffff00';
              break;
            case '3':
              feature.properties.color = '#00ff00';
              break;
            case '4':
              feature.properties.color = '#0000ff';
              break;
            case '10':
              feature.properties.color = '#030303';
              break;
            default:
              feature.properties.color = '#000000';
              break;
          }
        } else {
          ol = thisoverLayers.visualisations[group];
          let curoverlays = ol.find(x => x.category.toLowerCase() === cat.toLowerCase()).overlays;
          let color = curoverlays.find(x => x.name.toLowerCase() === name.toLowerCase()).color;
          feature.properties.color = color;
        }
      }
    });

    const items = curGeoJson.features.reduce(function (r, a) {
      r[a.properties.layername] = r[a.properties.layername] || [];
      r[a.properties.layername].push(a);
      return r;
    }, Object.create(null));

    let layers: any = [];
    let layertype = '';

    for (const [key, value] of Object.entries(items)) {
      let keys = key.toString().split('.');
      layertype = keys[0].toString();
      if (keys.length > 2) {
        layertype += '_' + keys[1].toString();
      }
      layers.push({ key: key.toString().split('.').pop(), value: value });
    }

    layers.sort((a, b) => a.key.localeCompare(b.key));

    if (format == 'Json') {
      let geojsonString = JSON.stringify(curGeoJson);
      let blob = new Blob([geojsonString], { type: 'text/json' });
      this.apiservice.downloadBlobAsFile(blob, 'GeoJson.json');
      return;
    }

    if (format == 'pdf') {
      let minX: number = Number.MAX_VALUE;
      let minY: number = Number.MAX_VALUE;
      let maxX: number = Number.MIN_VALUE;
      let maxY: number = Number.MIN_VALUE;

      curGeoJson.features.forEach(feature => {
        this.forEachCoordinate(feature.geometry, c => {
          const [x, y] = c;
          if (x > maxX) maxX = x;
          if (x < minX) minX = x;
          if (y > maxY) maxY = y;
          if (y < minY) minY = y;
        });
      });

      let send = {
        name: layertype,
        layers: layers,
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY,
      };

      this.apiservice
        .getMapPDF(send)
        .pipe()
        .subscribe((res: any) => {
          if (res != null) {
            const byteCharacters = atob(res.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], { type: 'text/dxf' });
            this.apiservice.downloadBlobAsFile(blob, res.name);
            Object.keys(this.overLayers.visualisations[this.visumode[0]][this.visumode[1]].overlays).forEach(id => {
              this.changeOverlayState(this.visumode[0], this.visumode[1], parseInt(id), 0);
            });
          } else {
            this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten'));
          }
        });

      return;
    }

    if (format == 'DXF') {
      let send = {
        name: layertype,
        layers: layers,
        epgs: exEPSG,
      };

      this.apiservice
        .getDXF(send)
        .pipe()
        .subscribe((res: any) => {
          if (res != null) {
            const byteCharacters = atob(res.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], { type: 'text/dxf' });
            this.apiservice.downloadBlobAsFile(blob, res.name);
          } else {
            this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten'));
          }
        });
    }
  }

  forEachCoordinate(geometry: GeoJSONGeometry, callback: (coord: number[]) => void) {
    if (!geometry) return;

    switch (geometry.type) {
      case 'Point':
        callback(geometry.coordinates as number[]);
        break;
      case 'MultiPoint':
      case 'LineString':
        (geometry.coordinates as number[][]).forEach(callback);
        break;
      case 'MultiLineString':
      case 'Polygon':
        (geometry.coordinates as number[][][]).forEach(ring => ring.forEach(callback));
        break;
      case 'MultiPolygon':
        (geometry.coordinates as number[][][][]).forEach(polygon => polygon.forEach(ring => ring.forEach(callback)));
        break;
    }
  }

  findBauformLayerName(curName: string, bauform) {
    let n = curName.split(',');
    let nn = curName;

    bauform.overlays.forEach(function (overlay) {
      n.forEach(function (key) {
        if (key == overlay.key) {
          nn = overlay.key;
        }
      });
    });

    return nn;
  }

  selBauform: any;
  panelBauformChange(event, bauform) {
    this.selBauform = undefined;
    if (event) {
      this.selBauform = bauform;
    }
  }

  disableAllOverlays(exceptVisuMode: any) {
    for (let i = 1; i < this.overLayers.base.length; i++) {
      if (exceptVisuMode[0] == 'base') {
        if (i != exceptVisuMode[1]) {
          let j = 0;
          for (let ovrl of this.overLayers.base[i].overlays) {
            if (ovrl.enable === true) {
              this.changeOverlayState('base', i, j, false);
            }
            j++;
          }
        }
      } else {
        let j = 0;
        for (let ovrl of this.overLayers.base[i].overlays) {
          if (ovrl.enable === true) {
            this.changeOverlayState('base', i, j, false);
          }
          j++;
        }
      }
    }

    for (let grp of Object.keys(this.overLayers.visualisations)) {
      this.overLayers.visualisations[grp].forEach((cat, i) => {
        if (
          !(grp == exceptVisuMode[0] && i == exceptVisuMode[1]) &&
          !(grp == 'kavseg' && exceptVisuMode[0] == 'kavseg')
        ) {
          let j = 0;
          for (let ovrl of cat.overlays) {
            if (ovrl.enable === true) {
              this.changeOverlayState(grp, i, j, false);
            }
            j++;
          }
        }
      });
    }

    if (exceptVisuMode[0] != 'measurements') {
      this.gleisMessFilter = {};
      this.gleisMessLayer.getSource().refresh();
    }
  }

  changeOverlayState(group: string, i: number, j: number, event, force: boolean = false) {
    this.curentGeoJson = undefined;

    let evt = !!event;
    let ol;
    let timeout = 0;

    let newVisumode = [group, i];
    if (
      this.visumode &&
      evt &&
      !(group == 'base' && i == 0) &&
      JSON.stringify(this.visumode) != JSON.stringify(newVisumode)
    ) {
      this.disableAllOverlays(newVisumode);
      this.visumode = newVisumode;
    }

    if (group == 'base') {
      ol = this.overLayers.base;
    } else {
      ol = this.overLayers.visualisations[group];
    }
    if (group == 'kavseg') {
      timeout = j * 500; //Race Condition - da KAT3 viel länger braucht, muss das als erstes geladen werden, ansonsten ist die Reihenfolge falsch
    }

    if (!(ol[i].overlays[j].enable !== false && evt !== false) || force) {
      let key: string;
      key = ol[i].overlays[j].key;
      if (!this.curMapSet) this.curMapSet = 1;

      if (key.startsWith('railprofiles.')) {
        key = 'railprofiles.' + this.railprofilesOverlays[j].val;

        if (event == 1) {
          let numUeber = key.split('.')[1];
          let features = this.railProfilesLayer.getSource().getFeatures();
          features = features.filter(
            x => x.getProperties()['NoP_GC_' + this.vauleGrinding.toString().replace('.', '')] == numUeber
          );
          features.forEach(feat => {
            feat.setProperties({ layername: key });
            feat.setProperties({ color: this.railprofilesOverlays[j].color });
            feat.setProperties({ OTYPID: '2' });
            feat.setProperties({ guid: uuidv4() });
          });
          this.Featurecache.set(key, features);

          this.curentGeoJson = features;
        }
        if (event == 0 && this.Featurecache.has(key)) {
          for (let index = 0; index < this.Featurecache.get(key).length; index++) {
            const element = this.Featurecache.get(key)[index];
            element.setProperties({ layername: '' });
            element.setProperties({ OTYPID: '' });
          }
          this.Featurecache.delete(key);
        }
      } else if (!key.startsWith('objekttyp.') && event == 1) {
        setTimeout(() => {
          this.apiservice
            .getLayerFeatures(this.curMapSet, key, this.pruefungsTyp.KPRUVID(), this.filterItems)
            .pipe()
            .subscribe((res: any) => {
              if (!res) {
                this.toastr.error(this.mrTranslate.transform('Etwas ist schief gelaufen!'));
                return;
              }
              this.curentGeoJson = res;

              let src = this.topojsonLayer.getSource();
              let features = src.getFormat().readFeatures(res, {
                featureProjection: 'EPSG:3857',
              });
              src.addFeatures(features);
              this.Featurecache.set(key, features);
            });
        }, timeout);
      } else if (event == 0 && this.Featurecache.has(key)) {
        let src = this.topojsonLayer.getSource();
        for (let index = 0; index < this.Featurecache.get(key).length; index++) {
          const element = this.Featurecache.get(key)[index];
          src.removeFeature(element);
        }
        this.Featurecache.delete(key);
      }
      if (evt) {
        if (!(group == 'base' && i == 0)) {
          this.visumode = newVisumode;
        }
        this.overLayIds.push([group, i, j]);
        this.vectorLayerNames.splice(this.vectorLayerNames.indexOf(key), 1);
      } else if (!this.vectorLayerNames.includes(key)) {
        this.overLayIds.splice(this.overLayIds.indexOf([group, i, j]), 1);
        this.vectorLayerNames.push(key);
      }
      let newStyle = this.getLayerStyles();
      this.topojsonLayer.setStyle(newStyle);
      ol[i].overlays[j].enable = evt;
    }

    if (group == 'base') {
      const overlays = this.overLayers.base[0].overlays;

      const enableState = Object.fromEntries(overlays.map(item => [item.key, item.enable]));

      localStorage.setItem('overlayEnableState', JSON.stringify(enableState));
    }
  }

  setMangelBem(event: any) {
    this.showMangelBem = event.target.checked;
    this.getLayerStyles();
    this.changeOverlayState('sonstige', 0, 0, this.showMangelBem);
  }
  setObjText(event: any) {
    this.showObjText = event.target.checked;
    let newStyle = this.getLayerStyles();
    this.topojsonLayer.setStyle(newStyle);
  }

  showPosition(event: any) {
    const chkd = event.target.checked;

    this.geolocation.setProjection(this.curEPSG);
    this.geolocation.setTracking(chkd);

    let src = this.topojsonLayer.getSource();
    if (chkd) {
      src.addFeature(this.positionFeature);
      this.positionStyle.setImage(
        new Icon({
          src: 'assets/icons/person1.svg',
          scale: 0.2,
          anchor: [0.5, 1],
        })
      );

      this.positionFeature.setStyle(this.positionStyle);
      this.geolocation.on('change:position', ev => {
        if (ev.target) {
          const coord = fromLonLat(ev.target.getPosition());
          this.positionFeature.setGeometry(coord ? new Point(coord) : null);

          if (!this.setPosFeatOnce) {
            let pnt = new Point(this.positionFeature.getGeometry().getExtent());
            this.map.getView().fit(pnt, { padding: [170, 50, 30, 150], minResolution: 6 });
            this.setPosFeatOnce = true;
          }
        }
      });
      this.geolocation.changed();
    } else {
      this.setPosFeatOnce = false;
      src.removeFeature(this.positionFeature);
    }
  }

  tileSwitch(tileLayerCat: string, tileLayerKey: string) {
    Object.keys(this.tileLayers).forEach(catname => {
      Object.keys(this.tileLayers[catname]).forEach(layername => {
        try {
          this.tileLayers[catname][layername].setVisible(false);
        } catch {}
      });
    });
    this.tileLayers[tileLayerCat][tileLayerKey].setVisible(true);
    this.baseLayer = [tileLayerCat, tileLayerKey];
    const newStyle = this.getLayerStyles();
    this.topojsonLayer.setStyle(newStyle);

    this.persistanceService.set('karte', {
      p: this.baseLayer[0],
      m: this.baseLayer[1],
    });
  }

  isTileLayerChecked(key, k) {
    return JSON.stringify([key, k]) == JSON.stringify(this.baseLayer);
  }

  triggerOverlaySwitcher() {
    this.showOverlaySwitcher = !this.showOverlaySwitcher;
  }

  enlargeSidenav(event) {
    if (event.mode == 'full') {
      this.sidenavenlarged = event.val;
    } else if (event.mode == 'half') {
      this.split50 = event.val;
    } else if (event.mode == 'progress') {
      this.showprogressbar = event.val;
      this.progressbars = {};
    } else if (event.mode == 'hidden') {
      this.hidedetailview = event.val;
    } else if (event.mode == 'close') {
      this.split50 = false;
      this.sidenavenlarged = false;
      this.showdetailview = event.val;
      this.progressbars = {};
      this.showprogressbar = event.val;
      this.ostammid = undefined;
      this.activeElement = undefined;
      this.clickSelect.getFeatures().clear();
    }
  }

  enlargeProgressbar(val?) {
    if (val) {
      this.progressbarenlarged = true;
    } else {
      this.progressbarenlarged = !this.progressbarenlarged;
    }
    setTimeout(() => {
      this.updateMapSize();
    });
  }

  showProgressData(data) {
    if (data) {
      let railprof = [];

      if (this.filtertrailprofiles.length > 0) {
        railprof = this.railprofiles.filter(row => row['OSTAMMID'] == data.stammid);
      }

      data['railprof'] = railprof;
      data['profileslayer'] = this.railprofilesOverlays;
      let colnum = ((this.vauleGrinding * 10) / 100).toString().split('.')[1];
      if (colnum.length == 1) {
        colnum = colnum + '0';
      }
      let colAnz = 'NoP_GC_' + colnum;
      data['railprofcol'] = colAnz;

      this.progressbars = data;
      this.showprogressbar = true;
    }
  }

  handleScrub(event) {
    this.indexScrub = event;
  }

  reloadDetailview() {
    const tmp = this.ostammid;
    this.ostammid = undefined;
    setTimeout(() => {
      this.ostammid = tmp;
    }, 100);
  }
  camelCaseToSentence(str: string) {
    return (
      str.charAt(0).toUpperCase() +
      str
        .replace(/([A-Z]+)/g, ' $1')
        .replace(/([A-Z][a-z])/g, ' $1')
        .slice(1)
    );
  }

  underscoreToSentence(str: string) {
    return (
      str.charAt(0).toUpperCase() +
      str
        .replace(/_[a-z]/g, function (v) {
          return v.toUpperCase();
        })
        .replace('_', ' ')
        .slice(1)
    );
  }

  correctStammName(str: string) {
    if (str == 'Plannr') {
      return 'PlanNr';
    }
    let ret = str;
    ret = ret.replace(/ae/g, 'ä');
    ret = ret.replace(/ue/g, 'ü');
    ret = ret.replace(/oe/g, 'ö');
    return ret;
  }

  getMonthName(month: number) {
    let returnMonth;

    switch (month) {
      case 1:
        returnMonth = 'Januar';
        break;
      case 2:
        returnMonth = 'Februar';
        break;
      case 3:
        returnMonth = 'März';
        break;
      case 4:
        returnMonth = 'April';
        break;
      case 5:
        returnMonth = 'Mai';
        break;
      case 6:
        returnMonth = 'Juni';
        break;
      case 7:
        returnMonth = 'Juli';
        break;
      case 8:
        returnMonth = 'August';
        break;
      case 9:
        returnMonth = 'September';
        break;
      case 10:
        returnMonth = 'Oktober';
        break;
      case 11:
        returnMonth = 'November';
        break;
      case 12:
        returnMonth = 'Dezember';
        break;
    }
    return returnMonth;
  }

  private GetPointsOfArc(points: Vector[]) {
    let a = points[0];
    let b = points[1];
    let c = points[2];
    let d = 2 * (a[0] - c[0]) * (c[1] - b[1]) + 2 * (b[0] - c[0]) * (a[1] - c[1]);
    let m1 = Math.pow(a[0], 2) - Math.pow(c[0], 2) + Math.pow(a[1], 2) - Math.pow(c[1], 2);
    let m2 = Math.pow(c[0], 2) - Math.pow(b[0], 2) + Math.pow(c[1], 2) - Math.pow(b[1], 2);
    let nx = m1 * (c[1] - b[1]) + m2 * (c[1] - a[1]);
    let ny = m1 * (b[0] - c[0]) + m2 * (a[0] - c[0]);
    let cx = nx / d;
    let cy = ny / d;
    let dx = cx - a[0];
    let dy = cy - a[1];
    let distance = Math.sqrt(dx * dx + dy * dy);
    let va1 = new Vector(a[0] - cx, a[1] - cy);
    let vb1 = new Vector(b[0] - cx, b[1] - cy);
    let vc1 = new Vector(c[0] - cx, c[1] - cy);
    let xaxis1 = new Vector(1, 0);
    let startAngle = this.AngleBetween(xaxis1, va1);
    let sweepAngle = this.AngleBetween(va1, vb1) + this.AngleBetween(vb1, vc1);

    let NumersOfSegmets = this.GetNumberOfSegments(cx, cy, distance, startAngle, sweepAngle);
    let PointsLocal = this.PointsOnCircleSector(cx, cy, distance, startAngle, sweepAngle, NumersOfSegmets);
    let ARCCenterPoint = toLonLat([cx, cy]);

    let L = [];

    for (let i = 0; i <= PointsLocal.length - 1; i++) {
      let pn = [PointsLocal[i].X, PointsLocal[i].Y];
      L.push(pn);
    }

    return L;
  }

  AngleBetween(v1: Vector, v2: Vector): number {
    let sin = v1.X * v2.Y - v2.X * v1.Y;
    let cos = v1.X * v2.X + v1.Y * v2.Y;
    return Math.atan2(sin, cos) * (180 / Math.PI);
  }

  private GetNumberOfSegments(cx, cy, radius, StartAngle, SweepAngle) {
    let alpha = 180 + StartAngle;
    let LenghtOfSegments = 100000;
    let InternNumberOfSegments = 9;

    while (LenghtOfSegments > 2) {
      let p = this.CalcPoint(cx, cy, alpha, radius);
      let p0: Coordinate = toLonLat([p.X, p.Y]);
      p = this.CalcPoint(cx, cy, alpha + SweepAngle / InternNumberOfSegments, radius);
      let p1: Coordinate = toLonLat([p.X, p.Y]);
      let line = new LineString([p0, p1]);
      LenghtOfSegments = geoDesLength(line) * 1000;

      InternNumberOfSegments += 1;
    }

    return InternNumberOfSegments - 1;
  }

  private PointsOnCircleSector(
    cx: number,
    cy: number,
    radius: number,
    StartAngle: number,
    SweepAngle: number,
    NumberOfsegments: number
  ) {
    let Points = [];
    let alpha = 180 + StartAngle;

    for (let i = 0; i <= NumberOfsegments; i++) {
      Points.push(this.CalcPoint(cx, cy, alpha, radius));
      alpha = alpha + SweepAngle / NumberOfsegments;
    }

    return Points;
  }

  private CalcPoint(cx: number, cy: number, alpha: number, radius: number): Vector {
    let cos = Math.cos((alpha * 2 * Math.PI) / 360);
    let sin: number = Math.sin((alpha * 2 * Math.PI) / 360);
    let x = cos * radius;
    let y = sin * radius;
    return new Vector(cx - x, cy - y);
  }

  private convertToUnit(value: number) {
    return addUnitAbbreviationToText(convertValueToUnit(value, 1, 0, this.unitLength, false), 1, this.unitLength, true);
  }
}
class Vector {
  X: number;
  Y: number;

  constructor(xValue: number, yValue: number) {
    this.X = xValue;
    this.Y = yValue;
  }
}
